<template>
  <div class="gt">

    <!-- ════════════════════ DASHBOARD HEADER ════════════════════ -->
    <div class="gt-dash-header">
      <div class="gt-dash-header-top">
        <div>
          <div class="gt-eyebrow">TALLER · WORKSHOP MANAGER</div>
          <h1 class="gt-title">Gestionar taller</h1>
        </div>
        <div class="gt-header-actions">
          <div class="gt-stat-pill gt-stat-pill--primary">
            <i class="fa-solid fa-clipboard-list"></i>
            <strong>{{ formartedItems.length }}</strong>
            <span>reportes</span>
          </div>
          <div class="gt-stat-pill gt-stat-pill--info">
            <i class="fa-solid fa-truck-fast"></i>
            <strong>{{ skuPedidos.length }}</strong>
            <span>pedidos</span>
          </div>
          <div class="gt-stat-pill gt-stat-pill--danger" v-if="allReports.length > 0">
            <i class="fa-solid fa-triangle-exclamation"></i>
            <strong>{{ allReports.length }}</strong>
            <span>problemas</span>
          </div>
          <div class="gt-stat-pill gt-stat-pill--warning">
            <i class="fa-solid fa-scissors"></i>
            <strong>{{ tareasCorte.length }}</strong>
            <span>corte</span>
          </div>
          <div class="gt-stat-pill gt-stat-pill--secondary">
            <i class="fa-solid fa-people-carry-box"></i>
            <strong>{{ tareasPreparado.length }}</strong>
            <span>preparado</span>
          </div>
          <div class="gt-stat-pill gt-stat-pill--success">
            <i class="fa-solid fa-hands-holding-circle"></i>
            <strong>{{ tareasConfeccion.length }}</strong>
            <span>confección</span>
          </div>
        </div>
      </div>
    </div>

    <app-collapse class="mb-2">
      <app-collapse-item title="Reporte de producción" class="area-card border-left-primary">
        <template #header>
          <div class="section-header">
            <div class="d-flex align-items-center">
              <b-avatar variant="light-primary" size="40" class="mr-1">
                <i class="fa-solid fa-clipboard-list"></i>
              </b-avatar>
              <h4 class="mb-0">Reporte de producción</h4>
            </div>
            <b-badge variant="light-primary" pill class="px-1">{{ formartedItems.length }}</b-badge>
          </div>
        </template>
          <b-button
            variant="primary"
            class="mr-1 mb-1"
            @click="openModalProduccion()"
          >
            Añadir
          </b-button>

          <b-row>
            <b-col md="3">
              <b-form-group label="Buscar" label-for="v-texto-buscar">
                <b-form-input id="v-texto-buscar" type="text" placeholder=""  v-model="buscarProduccion"/>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Tipo" label-for="v-country">
                <v-select
                  id="v-country"
                  v-model="buscarProduccionVisibles"
                  :options="[{'text': 'Activos'}, {'text': 'Archivados'},{'text': 'Todos'}, ]"
                  label="text"
                />
              </b-form-group>
            </b-col>
          </b-row>


          <b-table
              :items="formartedItems"
              :fields="columnasTableProduccion"
              class="table table-borderless table-prevision"
              no-border-collapse
              sort-icon-left
              striped
              hover
              responsive
              small
              ref="tableProduccion"
            >
            <template #cell(options)="data">
              <b-button  v-b-tooltip.hover.top="'Editar'" @click="editarProduccion(data.item)" variant="outline-success" class="btn-circle"><i class="fa-solid fa-pen-to-square"></i></b-button>
              <b-button  v-b-tooltip.hover.top="'Imprimir'" @click="imprimirProduccion(data.item)" variant="outline-info" class="btn-circle"><i class="fa-solid fa-print"></i></b-button>
            </template>

            <template #cell(correcionesTotales)="data">
              <b-badge :variant="data.item.correcionesTotales > data.item.correcionesResueltas ? 'light-danger' : 'light-secondary'" pill>{{ data.item.correcionesTotales }}</b-badge>
            </template>

            <template #cell(correcionesResueltas)="data">
              <b-badge :variant="data.item.correcionesResueltas > 0 ? 'light-success' : 'light-secondary'" pill>{{ data.item.correcionesResueltas }}</b-badge>
            </template>

            <template #cell(options_archivar)="data">
              <b-button v-if="data.item.visible"  v-b-tooltip.hover.top="'Archivar'" @click="archivarProduccion(data.item)" variant="outline-warning" class="btn-circle"><i class="fa-solid fa-box-archive"></i></b-button>
              <b-button v-else v-b-tooltip.hover.top="'Desarchivar'" @click="desarchivarProduccion(data.item)" variant="outline-success" class="btn-circle"><i class="fa-solid fa-boxes-packing"></i></b-button>
              <b-button v-if="!data.item.visible" v-b-tooltip.hover.top="'Borrar'" @click="borrarProduccion(data.item)" variant="outline-danger" class="btn-circle"><i class="fa-solid fa-trash"></i></b-button>

            </template>

          </b-table>
        </app-collapse-item>
    </app-collapse>

     <b-modal
        id="modal-produccion"
        title="Reporte de producción"
        centered
        size="xl"
        hide-footer
        modal-class="gt-modal"
        @hidden="guardarProduccion"
        >

        <div style="text-align: center;" class="mb-1">
          <b-button
            class="finish-button"
            style="background-color: #3bab76 !important;
            border-color: #3bab76 !important;"
            @click="saveProduccion()"
          >
            {{ produccionInfo.id == 0 ? 'Crear reporte' : 'Guardar' }}
          </b-button>
        </div>

        <b-row>
          <b-col cols="12" class="mb-2">
            <h3 class="mb-0">Pedido</h3>
          </b-col>

          <b-col md="1">
            <b-form-group label="Pedido" label-for="v-last-name">
              <b-form-input id="v-last-name" placeholder=""  v-model="produccionInfo.pedido"/>
            </b-form-group>
          </b-col>              
          <b-col md="3">
            <b-form-group label="Producto" label-for="v-first-name">
              <v-select
                v-model="produccionInfo.producto"
                class="sku-select"
                :options="listadoProductosTitulos"
                :taggable="true"
              />
            </b-form-group>
          </b-col>
          <b-col md="1">
            <b-form-group label="Unidades" label-for="unidades">
              <b-form-input id="unidades" type="number" placeholder="Introduce las unidades" v-model="produccionInfo.unidades" @wheel.prevent/>
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="Fecha Inicio" label-for="fechaInicio">
              <b-form-input id="fechaInicio" placeholder="Introduce la fecha de inicio"  type="date" v-model="produccionInfo.fechaInicio" />
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="Fecha Fin" label-for="fechaFin">
              <b-form-input id="fechaFin" placeholder="Introduce la fecha de fin" type="date" v-model="produccionInfo.fechaFin" />
            </b-form-group>
          </b-col>

          <b-col md="1">
            <b-form-group label="Días" label-for="dias">
              <b-form-input id="dias" type="number" placeholder="Introduce los días" v-model="produccionInfo.dias" @wheel.prevent/>
            </b-form-group>
          </b-col>

          <b-col md="1">
            <b-form-group label="Horas" label-for="horas">
              <b-form-input id="horas" type="number" step="0.1" placeholder="Introduce las horas" v-model="produccionInfo.horas" @wheel.prevent/>
            </b-form-group>
          </b-col>

          <b-col md="1">
            <b-form-group label="Productividad" label-for="productividad">
              <b-form-input id="productividad" type="number" placeholder="Introduce la productividad" v-model="produccionInfo.productividad" @wheel.prevent/>
            </b-form-group>
          </b-col>

          <b-row v-if="produccionInfo.pedido == ''" style="padding-left: 20px; padding-right: 20px; width: 100%;" v-for="item, index in produccionInfo.desglosePedido" :key="'desglose-'+index" >
            <b-col md="4">
              <b-form-group label="Producto" label-for="desglose-text">
                <b-form-input id="desglose-text" placeholder="Producto" v-model="item.texto" />
              </b-form-group>
            </b-col>

            <b-col md="1">
              <b-form-group label="Unidades" label-for="cantidad">
                <b-form-input id="cantidad" type="number" placeholder="Introduce las unidades" v-model="item.cantidad" @wheel.prevent/>
              </b-form-group>
            </b-col>

            <b-col md="1">
              <b-button style="margin-top: 20px; float: right;" @click="delDesglosePedido(index)" variant="outline-danger" class="btn-circle"><i class="fa-solid fa-trash-can"></i></b-button>
            </b-col>
          </b-row>

          <b-button v-if="produccionInfo.pedido == ''" style="margin-left: 20px;" @click="addProducto()" variant="outline-success" class="btn-circle"><i class="fa-solid fa-plus"></i></b-button>

        
          <b-col cols="12" class="mb-2">
            <hr>
            <h3 class="mb-0">Inicio y Fin</h3>
          </b-col>

          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Corte</h5>
          </b-col>

          <b-row style="padding-left: 20px; padding-right: 20px; width: 100%;" v-for="item, index in produccionInfo.tiempos.corte" :key="'corte-'+index" >

              <b-col md="2">
                <b-form-group label="Info" label-for="corte-info">
                  <b-form-input id="corte-info" placeholder="Informacion" v-model="item.informacion" />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label="Fecha Inicio" label-for="corte-fechaInicio">
                  <b-form-input id="corte-fechaInicio" placeholder="Introduce la fecha de inicio" type="date" v-model="item.fechaInicio" />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label="Fecha Fin" label-for="corte-fechaFin">
                  <b-form-input id="corte-fechaFin" placeholder="Introduce la fecha de fin" type="date" v-model="item.fechaFin" />
                </b-form-group>
              </b-col>

              <b-col md="1">
                <b-form-group label="Hora Inicio" label-for="corte-horaInicio">
                  <b-form-input id="corte-horaInicio" placeholder="Introduce la hora de inicio" type="time" v-model="item.horaInicio" />
                </b-form-group>
              </b-col>

              <b-col md="1">
                <b-form-group label="Hora Fin" label-for="corte-horaFin">
                  <b-form-input id="corte-horaFin" placeholder="Introduce la hora de fin" type="time" v-model="item.horaFin" />
                </b-form-group>
              </b-col>

              <b-col md="1">
                <b-form-group label="Empleados" label-for="corte-empleados">
                  <b-form-input id="corte-empleados" placeholder="Introduce los empleados" v-model="item.empleados" />
                </b-form-group>
              </b-col>

              <b-col md="1">
                <b-form-group label="Horas Totales" label-for="corte-horasTotales">
                  <b-form-input id="corte-horasTotales" placeholder="Introduce las horas totales" v-model="item.horasTotales" />
                </b-form-group>
              </b-col>

              <b-col md="1">
                <b-form-group label="Productividad" label-for="corte-productividad">
                  <b-form-input id="corte-productividad" placeholder="Introduce la productividad" v-model="item.productividad" />
                </b-form-group>
              </b-col>

              <b-col md="1">
                <b-button style="margin-top: 20px; float: right;" @click="delProduccionCorte(index)" variant="outline-danger" class="btn-circle"><i class="fa-solid fa-trash-can"></i></b-button>
              </b-col>
              
          </b-row>

          <b-button style="margin-left: 20px;" @click="addProduccionCorte()" variant="outline-success" class="btn-circle"><i class="fa-solid fa-plus"></i></b-button>

          <b-col cols="12" class="mb-2">
            <hr>
            <h5 class="mb-0">Mano</h5>
          </b-col>

          <b-row style="padding-left: 20px; padding-right: 20px; width: 100%;" v-for="item, index in produccionInfo.tiempos.mano" :key="'mano-'+index" >

            <b-col md="2">
                <b-form-group label="Info" label-for="mano-info">
                  <b-form-input id="mano-info" placeholder="Informacion" v-model="item.informacion" />
                </b-form-group>
              </b-col>

            <b-col md="2">
              <b-form-group label="Fecha Inicio" label-for="mano-fechaInicio">
                <b-form-input id="mano-fechaInicio" placeholder="Introduce la fecha de inicio" type="date" v-model="item.fechaInicio" />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="Fecha Fin" label-for="mano-fechaFin">
                <b-form-input id="mano-fechaFin" placeholder="Introduce la fecha de fin" type="date" v-model="item.fechaFin" />
              </b-form-group>
            </b-col>

            <b-col md="1">
              <b-form-group label="Hora Inicio" label-for="mano-horaInicio">
                <b-form-input id="mano-horaInicio" placeholder="Introduce la hora de inicio" type="time" v-model="item.horaInicio" />
              </b-form-group>
            </b-col>

            <b-col md="1">
              <b-form-group label="Hora Fin" label-for="mano-horaFin">
                <b-form-input id="mano-horaFin" placeholder="Introduce la hora de fin" type="time" v-model="item.horaFin" />
              </b-form-group>
            </b-col>

            <b-col md="1">
              <b-form-group label="Empleados" label-for="mano-empleados">
                <b-form-input id="mano-empleados" placeholder="Introduce los empleados" v-model="item.empleados" />
              </b-form-group>
            </b-col>

            <b-col md="1">
              <b-form-group label="Horas Totales" label-for="mano-horasTotales">
                <b-form-input id="mano-horasTotales" placeholder="Introduce las horas totales" v-model="item.horasTotales" />
              </b-form-group>
            </b-col>

            <b-col md="1">
              <b-form-group label="Productividad" label-for="mano-productividad">
                <b-form-input id="mano-productividad" placeholder="Introduce la productividad" v-model="item.productividad" />
              </b-form-group>
            </b-col>

            <b-col md="1">
                <b-button style="margin-top: 20px; float: right;" @click="delProduccionMano(index)" variant="outline-danger" class="btn-circle"><i class="fa-solid fa-trash-can"></i></b-button>
            </b-col>

          </b-row>

          <b-button style="margin-left: 20px;" @click="addProduccionMano()" variant="outline-success" class="btn-circle"><i class="fa-solid fa-plus"></i></b-button>

          <b-col cols="12" class="mb-2">
            <hr>
            <h5 class="mb-0">Aparado</h5>
          </b-col>

          <b-row style="padding-left: 20px; padding-right: 20px; width: 100%;" v-for="item, index in produccionInfo.tiempos.aparado" :key="'aparado-'+index" >

            <b-col md="2">
                <b-form-group label="Info" label-for="aparado-info">
                  <b-form-input id="aparado-info" placeholder="Informacion" v-model="item.informacion" />
                </b-form-group>
              </b-col>

            <b-col md="2">
              <b-form-group label="Fecha Inicio" label-for="aparado-fechaInicio">
                <b-form-input id="aparado-fechaInicio" placeholder="Introduce la fecha de inicio" type="date" v-model="item.fechaInicio" />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="Fecha Fin" label-for="aparado-fechaFin">
                <b-form-input id="aparado-fechaFin" placeholder="Introduce la fecha de fin" type="date" v-model="item.fechaFin" />
              </b-form-group>
            </b-col>

            <b-col md="1">
              <b-form-group label="Hora Inicio" label-for="aparado-horaInicio">
                <b-form-input id="aparado-horaInicio" placeholder="Introduce la hora de inicio" type="time"  v-model="item.horaInicio" />
              </b-form-group>
            </b-col>

            <b-col md="1">
              <b-form-group label="Hora Fin" label-for="aparado-horaFin">
                <b-form-input id="aparado-horaFin" placeholder="Introduce la hora de fin" type="time" v-model="item.horaFin" />
              </b-form-group>
            </b-col>

            <b-col md="1">
              <b-form-group label="Empleados" label-for="aparado-empleados">
                <b-form-input id="aparado-empleados" placeholder="Introduce los empleados" v-model="item.empleados" />
              </b-form-group>
            </b-col>

            <b-col md="1">
              <b-form-group label="Horas Totales" label-for="aparado-horasTotales">
                <b-form-input id="aparado-horasTotales" placeholder="Introduce las horas totales" v-model="item.horasTotales" />
              </b-form-group>
            </b-col>

            <b-col md="1">
              <b-form-group label="Productividad" label-for="aparado-productividad">
                <b-form-input id="aparado-productividad" placeholder="Introduce la productividad" v-model="item.productividad" />
              </b-form-group>
            </b-col>

            <b-col md="1">
                <b-button style="margin-top: 20px; float: right;" @click="delProduccionAparado(index)" variant="outline-danger" class="btn-circle"><i class="fa-solid fa-trash-can"></i></b-button>
            </b-col>

          </b-row>

          <b-button style="margin-left: 20px;" @click="addProduccionAparado()" variant="outline-success" class="btn-circle"><i class="fa-solid fa-plus"></i></b-button>

          <b-col cols="12" class="mb-2">
            <hr>
            <h3 class="mb-0">Correcciones <i style="margin-left: 10px;"  v-b-tooltip.hover.top="'Apuntar todas las correcciones hechas o por hacer de esta producción y marcar como hecho una vez finalizado.'"  class="fa-solid fa-circle-info"></i></h3>
            

          </b-col>

          <b-row style="padding-left: 20px; padding-right: 20px; width: 100%;" v-for="item, index in produccionInfo.correciones" :key="'corecciones-'+index" >

            <b-col md="10">
              <b-form-group label="Correciones" label-for="correciones">
                <b-form-textarea id="correciones" rows="4" placeholder="Introduce las correcciones" v-model="item.texto" />
              </b-form-group>
            </b-col>

            <b-col md="1" >
              <b-button style="margin-top: 20px" v-if="item.solucionado" variant="outline-success" class="btn-circle" @click="item.solucionado = false"><i class="fa-solid fa-check"></i></b-button>
              <b-button style="margin-top: 20px" v-else variant="outline-danger" class="btn-circle" @click="item.solucionado = true"><i class="fa-solid fa-hammer"></i></b-button>
            </b-col>

            <b-col md="1" v-if="index > 0">
                <b-button style="margin-top: 20px; float: right;" @click="delProduccionCorrecion(index)" variant="outline-danger" class="btn-circle"><i class="fa-solid fa-trash-can"></i></b-button>
            </b-col>

          </b-row>

          <b-button style="margin-left: 20px;" @click="addProduccionCorrecion()" variant="outline-success" class="btn-circle"><i class="fa-solid fa-plus"></i></b-button>

          <b-col cols="12" class="mb-2">
            <hr>
            <h3 class="mb-0">Timeline <i style="margin-left: 10px;"  v-b-tooltip.hover.top="'Apuntar todos los sucesos relevantes diarios de la produccion, faltas, mejoras, cambios en las guías, errores de confección, pérdidas, ideas, observaciones, acontecimientos fuera de lo común, etc'"  class="fa-solid fa-circle-info"></i></h3>
          </b-col>

          <b-row style="padding-left: 20px; padding-right: 20px; width: 100%;" v-for="item, index in produccionInfo.timeline" :key="'timeline-'+index" >

            <b-col md="2">
              <b-form-group label="Fecha" label-for="timeline-fechaInicio">
                <b-form-input id="timeline-fechaInicio" placeholder="Introduce la fecha" type="date" v-model="item.fecha" />
              </b-form-group>
            </b-col>

            <b-col md="9">
              <b-form-group label="Timeline" label-for="timeline">
                <b-form-textarea rows="5" id="timeline" placeholder="Introduce el timeline" v-model="item.texto" />
              </b-form-group>
            </b-col>

            <b-col md="1" v-if="index > 0">
                <b-button style="margin-top: 20px; float: right;" @click="delProduccionTimeline(index)" variant="outline-danger" class="btn-circle"><i class="fa-solid fa-trash-can"></i></b-button>
            </b-col>
         </b-row>

         <b-button style="margin-left: 20px;" @click="addProduccionTimeline()" variant="outline-success" class="btn-circle"><i class="fa-solid fa-plus"></i></b-button>

          <b-col cols="12" class="mb-2">
            <hr>
            <h3 class="mb-0">Observaciones <i style="margin-left: 10px;"  v-b-tooltip.hover.top="'Apuntar aquî las recomendaciones especîficas de este producto que deberîamos tener en cuenta para la próxima vez que cojamos de nuevo este producto.'"  class="fa-solid fa-circle-info"></i></h3>
          </b-col>

          <b-col md="12">
            <b-form-group label="Observaciones" label-for="observaciones">
              <b-form-textarea rows="8" id="observaciones" placeholder="Introduce aquí tus recomendaciones para la siguiente producción" v-model="produccionInfo.observaciones" />
            </b-form-group>
          </b-col>

        </b-row>

        <div style="text-align: center;">
          <b-button
            
            class="finish-button"
            style="background-color: #3bab76 !important;
            border-color: #3bab76 !important;"
            @click="saveProduccion()"
          >
            Guardar
          </b-button>
        </div>
       

    </b-modal>

    <div ref="contenidoParaImprimir" class="invoice-preview">
      <div class="invoice-container">
        <h3 class="invoice-title">Producción - {{ formatearFecha(produccionPrint.fechaInicio) }}</h3>

        <table>
            <thead>
                <tr>
                    <th><strong>Producto</strong></th>
                    <th><strong>UD</strong></th>
                    <th><strong>Inicio</strong></th>
                    <th><strong>Fin</strong></th>
                    <th><strong>Días</strong></th>
                    <th><strong>Horas</strong></th>
                    <th><strong>Prod</strong></th>
                    <th><strong>Cor Totales</strong></th>
                    <th><strong>Cor Resueltas</strong></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ produccionPrint.producto }}</td>
                    <td>{{ produccionPrint.unidades }}</td>
                    <td>{{ formatearFechaCorta(produccionPrint.fechaInicio) }}</td>
                    <td>{{ formatearFechaCorta(produccionPrint.fechaFin) }}</td>
                    <td>{{ produccionPrint.dias }}</td>
                    <td>{{ produccionPrint.horas }}</td>
                    <td>{{ produccionPrint.productividad }}</td>
                    <td>{{ produccionPrint.correcionesTotales }}</td>
                    <td>{{ produccionPrint.correcionesResueltas }}</td>
                </tr>
            </tbody>
        </table>

        <div class="section">
          <p><strong>Pedido: </strong>{{ produccionPrint.pedido }}</p>
          <p v-for="item, index in produccionPrint.pedidoInfo.listaSku" :key="'itemspedido-'+index">
            <b>{{ item.sku }}</b> - {{ item.cantidad }} unidades
          </p>
        </div>

        <div class="section">
          <h2>Correcciones</h2>
          <p v-for="(item, index) in produccionPrint.correciones" :key="'correcion-print-'+index" v-if="item.texto">
            <span v-if="item.solucionado">✔️</span>
            <span v-else>❌</span>
            - {{ item.texto }}
          </p>
        </div>


        <div class="section">
          <h2>Observaciones</h2>
          <p v-html="produccionPrint.observaciones.replace(/\n/g, '<br>')"></p>
        </div>

        <div class="section" v-if="produccionPrint.tiempos.corte.some(item => item.fechaInicio && item.fechaInicio !== 'Sin definir')">
            <h2>Corte</h2>
            <div v-for="(item, index) in produccionPrint.tiempos.corte" :key="'corte-print-'+index" style="margin-bottom: 10px;">
              <span> <strong>Información:</strong> {{ item.informacion || "N/A" }} </span> 
              <span> <strong>Fecha Inicio:</strong> {{ item.fechaInicio || "Sin definir" }} </span> 
              <span> <strong>Fecha Fin:</strong> {{ item.fechaFin || "Sin definir" }} </span> 
              <span> <strong>Hora Inicio:</strong> {{ item.horaInicio || "Sin definir" }} </span> 
              <br>
              <span> <strong>Hora Fin:</strong> {{ item.horaFin || "Sin definir" }} </span> 
              <span> <strong>Empleados:</strong> {{ item.empleados || "N/A" }} </span> 
              <span> <strong>Horas Totales:</strong> {{ item.horasTotales }} horas </span> 
            </div>
          </div>

          <div class="section" v-if="produccionPrint.tiempos.mano.some(item => item.fechaInicio && item.fechaInicio !== 'Sin definir')">
            <h2>Mano</h2>
            <div v-for="(item, index) in produccionPrint.tiempos.mano" :key="'mano-print-'+index" style="margin-bottom: 10px;">
              <span> <strong>Información:</strong> {{ item.informacion || "N/A" }} </span> 
              <span> <strong>Fecha Inicio:</strong> {{ item.fechaInicio || "Sin definir" }} </span> 
              <span> <strong>Fecha Fin:</strong> {{ item.fechaFin || "Sin definir" }} </span> 
              <span> <strong>Hora Inicio:</strong> {{ item.horaInicio || "Sin definir" }} </span> 
              <br>
              <span> <strong>Hora Fin:</strong> {{ item.horaFin || "Sin definir" }} </span> 
              <span> <strong>Empleados:</strong> {{ item.empleados || "N/A" }} </span> 
              <span> <strong>Horas Totales:</strong> {{ item.horasTotales }} horas </span> 
            </div>
          </div>

          <div class="section" v-if="produccionPrint.tiempos.aparado.some(item => item.fechaInicio && item.fechaInicio !== 'Sin definir')">
            <h2>Aparado</h2>
            <div v-for="(item, index) in produccionPrint.tiempos.aparado" :key="'aparado-print-'+index" style="margin-bottom: 10px;">
              <span> <strong>Información:</strong> {{ item.informacion || "N/A" }} </span>
              <span> <strong>Fecha Inicio:</strong> {{ item.fechaInicio || "Sin definir" }} </span>
              <span> <strong>Fecha Fin:</strong> {{ item.fechaFin || "Sin definir" }} </span>
              <span> <strong>Hora Inicio:</strong> {{ item.horaInicio || "Sin definir" }} </span>
              <br>
              <span> <strong>Hora Fin:</strong> {{ item.horaFin || "Sin definir" }} </span>
              <span> <strong>Empleados:</strong> {{ item.empleados || "N/A" }} </span>
              <span> <strong>Horas Totales:</strong> {{ item.horasTotales }} horas </span>
            </div>
          </div>

        <div class="page-break section">
          <br>
          <h2>Timeline</h2>
          <div v-for="(item, index) in produccionPrint.timeline" :key="'timeline-print-'+index" class="timeline-item" v-if="item.texto">
            <p class="timeline-date">{{ formatearFecha(item.fecha) }}</p>
            <ul>
              <li v-for="(line, lineIndex) in item.texto.split('\n').filter(line => line.trim() !== '')" :key="'line-'+lineIndex">{{ line }}</li>
            </ul>
          </div>
        </div>

      </div>
    </div>

    <app-collapse class="mb-2">
      <app-collapse-item title="Pedidos aceptados" class="area-card border-left-info">
        <template #header>
          <div class="section-header">
            <div class="d-flex align-items-center">
              <b-avatar variant="light-info" size="40" class="mr-1">
                <i class="fa-solid fa-truck-fast"></i>
              </b-avatar>
              <h4 class="mb-0">Pedidos aceptados</h4>
            </div>
            <b-badge variant="light-info" pill class="px-1">{{ skuPedidos.length }}</b-badge>
          </div>
        </template>
          <div v-if="skuPedidos.length === 0" class="empty-state">
            <i class="fa-solid fa-inbox"></i>
            <p class="mt-1">No hay pedidos aceptados pendientes</p>
          </div>
          <b-table
            v-else
              :items="skuPedidos"
              :fields="columnasTablePedidos"
              class="table table-borderless table-prevision"
              no-border-collapse
              sort-icon-left
              striped
              hover
              responsive
              small
              ref="tablePedidos"
            >

            <template #cell(sku)="data">

              <span :id="'tooltip-button-'+data.item.index" @click="data.item.show = !data.item.show">
                {{ data.item.sku }}
              </span>
                
              <b-tooltip :show.sync="data.item.show" :target="'tooltip-button-'+data.item.index" placement="top">
                {{data.item.titulo}}
              </b-tooltip>

            </template>

            <template #cell(options)="data">
              <b-button v-if="data.item.corteDisponible" v-b-tooltip.hover.top="'Enviar a corte'" variant="flat-warning" class="btn-circle" @click="addToCorte(data.item)"><i class="fa-solid fa-scissors"></i> <span class="d-none d-lg-inline">Corte</span></b-button>
              <b-button v-if="data.item.preparadoDisponible" v-b-tooltip.hover.top="'Enviar a preparado'" variant="flat-secondary" class="btn-circle" @click="addToPreparado(data.item)"><i class="fa-solid fa-people-carry-box"></i> <span class="d-none d-lg-inline">Preparado</span></b-button>
              <b-button v-if="data.item.manoDisponible" v-b-tooltip.hover.top="'Enviar a confección'" variant="flat-success" class="btn-circle" @click="addToConfeccion(data.item)"><i class="fa-solid fa-hands-holding-circle"></i> <span class="d-none d-lg-inline">Confección</span></b-button>
            </template>

            <template #cell(refArchivar)="data">
              <b-button variant="outline-secondary" v-b-tooltip.hover.top="'Archivar'" class="btn-circle" @click="addToArchivar(data.item)" ><i class="fa-solid fa-box-archive"></i></b-button>
            </template>

          </b-table>
        </app-collapse-item>
    </app-collapse>

    <app-collapse v-if="allReports.length > 0" class="mb-2">
      <app-collapse-item title="Problemas reportados" class="area-card border-left-danger">
        <template #header>
          <div class="section-header">
            <div class="d-flex align-items-center">
              <b-avatar variant="light-danger" size="40" class="mr-1">
                <i class="fa-solid fa-triangle-exclamation"></i>
              </b-avatar>
              <h4 class="mb-0">Problemas reportados</h4>
            </div>
            <b-badge variant="light-danger" pill class="px-1">{{ allReports.length }}</b-badge>
          </div>
        </template>
          <b-table
              :items="allReports"
              :fields="columnasReportes"
              class="table table-borderless table-prevision"
              no-border-collapse
              sort-icon-left
              striped
              hover
              responsive
              small
              ref="tableReports"
            >

              <template #cell(options)="data">
                <b-button variant="outline-success" v-b-tooltip.hover.top="'Solucionado'" class="btn-circle" @click="reportSolucionado(data.item)"><i class="fa-solid fa-check-double"></i></b-button>
              </template>

              <template #cell(sku)="data">
                <span>{{data.item.sku}}-{{data.item.color}}</span>
              </template>

          </b-table>
        </app-collapse-item>
    </app-collapse>

    <app-collapse class="mb-2">
      <app-collapse-item title="Tareas de corte" class="area-card border-left-warning">
        <template #header>
          <div class="section-header">
            <div class="d-flex align-items-center">
              <b-avatar variant="light-warning" size="40" class="mr-1">
                <i class="fa-solid fa-scissors"></i>
              </b-avatar>
              <h4 class="mb-0">Tareas de corte</h4>
            </div>
            <b-badge variant="light-warning" pill class="px-1">{{ tareasCorte.length }}</b-badge>
          </div>
        </template>
          <div v-if="tareasCorte.length === 0" class="empty-state">
            <i class="fa-solid fa-inbox"></i>
            <p class="mt-1">No hay tareas de corte pendientes</p>
          </div>
          <b-table
              v-else
              :items="tareasCorte"
              :fields="columnasTableCorte"
              class="table table-borderless table-prevision"
              no-border-collapse
              sort-icon-left
              striped
              hover
              responsive
              small
              ref="tableCorte"
            >

              <template #cell(options)="data">
                  <b-button v-b-tooltip.hover.top="'Quitar de corte'" v-if="data.item.cortePiel > 0 || data.item.corteForros > 0 || data.item.corteRefuerzos" variant="outline-danger" @click="delToCorte(data.item)" class="btn-circle"><i class="fa-solid fa-trash-can"></i></b-button>
                  <b-button v-else v-b-tooltip.hover.top="'Terminado'" @click="delToCorte(data.item)" variant="outline-dark" class="btn-circle" ><i class="fa-solid fa-check"></i></b-button>
              </template>

              <template #cell(order)="data">
                  <b-button variant="outline-secondary" class="btn-icon rounded-circle mb-50" @click="moveCorte(data.item, true)" >
                      <feather-icon icon="ChevronUpIcon" />
                  </b-button>
                  <b-button variant="outline-secondary" class="btn-icon rounded-circle" @click="moveCorte(data.item, false)" >
                      <feather-icon icon="ChevronDownIcon" />
                  </b-button>
              </template>

              <template #cell(cortePiel)="data">
                
                <span :class="getStyleStatus(data.item, 'piel')">
                  <b>{{data.item.cortePiel}}</b>
                  <span v-if="getStyleStatus(data.item, 'piel') == 'corte-proceso'"> / {{data.item.totalNumCortePiel}}</span>
                </span>
              </template>

              <template #cell(corteForros)="data">
                <span :class="getStyleStatus(data.item, 'forros')"><b>{{data.item.corteForros}}</b> <span v-if="getStyleStatus(data.item, 'forros') == 'corte-proceso'"> / {{data.item.totalNumCorteForros}}</span></span>
              </template>

              <template #cell(corteRefuerzos)="data">
                <span :class="getStyleStatus(data.item, 'refuerzos')"><b>{{data.item.corteRefuerzos}}</b><span v-if="getStyleStatus(data.item, 'refuerzos') == 'corte-proceso'"> / {{data.item.totalNumCorteRefuerzos}}</span></span>
              </template>

          </b-table>
        </app-collapse-item>
    </app-collapse>

    <app-collapse class="mb-2">
      <app-collapse-item title="Tareas de preparado" class="area-card border-left-secondary">
        <template #header>
          <div class="section-header">
            <div class="d-flex align-items-center">
              <b-avatar variant="light-secondary" size="40" class="mr-1">
                <i class="fa-solid fa-people-carry-box"></i>
              </b-avatar>
              <h4 class="mb-0">Tareas de preparado</h4>
            </div>
            <b-badge variant="light-secondary" pill class="px-1">{{ tareasPreparado.length }}</b-badge>
          </div>
        </template>
          <div v-if="tareasPreparado.length === 0" class="empty-state">
            <i class="fa-solid fa-inbox"></i>
            <p class="mt-1">No hay tareas de preparado pendientes</p>
          </div>
          <b-table
              v-else
              :items="tareasPreparado"
              :fields="columnasTablePreparado"
              class="table table-borderless table-prevision"
              no-border-collapse
              sort-icon-left
              striped
              hover
              responsive
              small
              ref="tablePreparado"
              :tbody-tr-class="rowClassPreparado"
            >

              <template #cell(options)="data">
                <b-button variant="outline-danger"  v-b-tooltip.hover.top="'Quitar de preparado'"  @click="delToPreparado(data.item)" class="btn-circle"><i class="fa-solid fa-trash-can"></i></b-button>
              </template>

              <template #cell(order)="data">
                <b-button variant="outline-secondary" class="btn-icon rounded-circle mb-50" @click="movePreparado(data.item, true)" >
                    <feather-icon icon="ChevronUpIcon" />
                </b-button>
                <b-button variant="outline-secondary" class="btn-icon rounded-circle" @click="movePreparado(data.item, false)" >
                    <feather-icon icon="ChevronDownIcon" />
                </b-button>
              </template>

          </b-table>
        </app-collapse-item>
    </app-collapse>

    <app-collapse class="mb-2">
      <app-collapse-item title="Tareas de confección" class="area-card border-left-success">
        <template #header>
          <div class="section-header">
            <div class="d-flex align-items-center">
              <b-avatar variant="light-success" size="40" class="mr-1">
                <i class="fa-solid fa-hands-holding-circle"></i>
              </b-avatar>
              <h4 class="mb-0">Tareas de confección</h4>
            </div>
            <b-badge variant="light-success" pill class="px-1">{{ tareasConfeccion.length }}</b-badge>
          </div>
        </template>
          <div v-if="tareasConfeccion.length === 0" class="empty-state">
            <i class="fa-solid fa-inbox"></i>
            <p class="mt-1">No hay tareas de confección pendientes</p>
          </div>
          <b-table
              v-else
              :items="tareasConfeccion"
              :fields="columnasTableConfeccion"
              class="table table-borderless table-prevision"
              no-border-collapse
              sort-icon-left
              striped
              hover
              responsive
              small
              ref="tableConfeccion"
              :tbody-tr-class="rowClass"
            >

              <template #cell(options)="data">
                  <b-button  v-b-tooltip.hover.top="'Quitar de confección'"  v-if="data.item.completados == ''" variant="outline-danger" @click="delToConfeccion(data.item)" class="btn-circle"><i class="fa-solid fa-trash-can"></i></b-button>
                  <b-button  v-b-tooltip.hover.top="'Terminado'"  v-else @click="delToConfeccion(data.item)" variant="outline-dark" class="btn-circle" ><i class="fa-solid fa-check"></i></b-button>
              </template>

              <template #cell(order)="data">
                  <b-button variant="outline-secondary" class="btn-icon rounded-circle mb-50" @click="moveConfeccion(data.item, true)" >
                      <feather-icon icon="ChevronUpIcon" />
                  </b-button>
                  <b-button variant="outline-secondary" class="btn-icon rounded-circle" @click="moveConfeccion(data.item, false)" >
                      <feather-icon icon="ChevronDownIcon" />
                  </b-button>
              </template>

          </b-table>
        </app-collapse-item>
    </app-collapse>
  </div>
</template>

<script>
import axios from '@axios'
/*import VueApexCharts from 'vue-apexcharts'*/
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { BTable, BFormInput, BFormGroup, BRow, BCol, VBTooltip, BBadge, BAvatar} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { t } from '@/@core/libs/i18n/utils'

  export default {
    components: {
        BTable,
        BFormInput,
        BFormGroup,
        BRow,
        BCol,
        BBadge,
        BAvatar,
        vSelect,
        AppCollapse,
        AppCollapseItem,
    },
    directives: {
      'b-tooltip': VBTooltip,
    },
    data () {
      return {
        columnasTableProduccion: [
        {
          key: "options",
          label: "",
          thStyle: { width: "10%" },
        },
        {
          key: "producto",
          label: "Producto",
          sortable: true,
        },{
          key: "pedido",
          label: "Pedido",
          sortable: true,
        },{
          key: "unidades",
          label: "Unidades",
          sortable: true,
        },{
          key: "fechaInicio",
          label: "Fecha Inicio",
          sortable: true,
        },{
          key: "fechaFin",
          label: "Fecha Fin",
          sortable: true,
        },{
          key: "dias",
          label: "Dias",
          sortable: true,
        },{
          key: "horas",
          label: "Horas",
          sortable: true,
        },{
          key: "productividad",
          label: "Productividad",
          sortable: true,
        },{
          key: "correcionesTotales",
          label: "Correciones",
          sortable: true,
        },{
          key: "correcionesResueltas",
          label: "Resueltas",
          sortable: true,
        },
        {
          key: "options_archivar",
          label: "",
          thStyle: { width: "10%" },
        },
        ],
        columnasTablePedidos: [
        {
          key: "refArchivar",
          label: "Archivar",
          sortable: false,
        },
        {
          key: "refPedido",
          label: "Pedido",
          sortable: true,
        },{
          key: "sku",
          label: "Sku",
          sortable: true,
        },{
          key: "fecha",
          label: "Entrega",
          sortable: true,
        },{
          key: "cantidad",
          label: "Cantidad",
          sortable: true,
        },/*{
          key: "completados",
          label: "Completados",
          sortable: true,
        },*/{
          key: "cortePiel",
          label: "Piel",
          sortable: true,
        },{
          key: "corteForros",
          label: "Forros",
          sortable: true,
        },{
          key: "corteRefuerzos",
          label: "Refuerzos",
          sortable: true,
        },{
          key: "options",
          label: "",
          thStyle: { width: "20%" },
        }],
        columnasTableCorte: [
        {
          key: "order",
          label: "",
          thStyle: { width: "5%" },
        },
        {
          key: "refPedido",
          label: "Pedido",
          sortable: true,
        },{
          key: "sku",
          label: "Sku",
          sortable: true,
        },{
          key: "cantidad",
          label: "Ud",
          sortable: true,
        },{
          key: "cortePiel",
          label: "Piel",
          sortable: true,
        },{
          key: "corteForros",
          label: "Forros",
          sortable: true,
        },{
          key: "corteRefuerzos",
          label: "Refuerzos",
          sortable: true,
        },{
          key: "options",
          label: "",
          thStyle: { width: "10%" },
        }],
        columnasReportes: [
        {
          key: "fecha",
          label: "Fecha",
          sortable: true,
          thStyle: { width: "10%" },
        },
        {
          key: "sku",
          label: "Sku",
          sortable: true,
          thStyle: { width: "20%" },
        },
        {
          key: "categoria",
          label: "Categoria",
          sortable: true,
          thStyle: { width: "10%" },
        },
         {
          key: "descripcion",
          label: "Descripcion",
          sortable: true,
        },{
          key: "options",
          label: "",
          thStyle: { width: "10%" },
        }
        ],
         columnasTableConfeccion: [
        {
          key: "order",
          label: "",
          thStyle: { width: "5%" },
        },
        {
          key: "refPedido",
          label: "Pedido",
          sortable: true,
        },{
          key: "sku",
          label: "Sku",
          sortable: true,
        },{
          key: "cantidad",
          label: "Cantidad",
          sortable: true,
        },{
          key: "completados",
          label: "Completados",
          sortable: true,
        },{
          key: "options",
          label: "",
          thStyle: { width: "10%" },
        }],
        columnasTablePreparado: [
        {
          key: "order",
          label: "",
          thStyle: { width: "5%" },
        },
        {
          key: "refPedido",
          label: "Pedido",
          sortable: true,
        },
        /*{
          key: "fecha",
          label: "Fecha",
          sortable: true,
        },*/{
          key: "sku",
          label: "Sku",
          sortable: true,
        },{
          key: "cantidad",
          label: "Cantidad",
          sortable: true,
        },{
          key: "options",
          label: "",
          thStyle: { width: "10%" },
        }],
        pedidos: [],
        skuPedidos: [],
        allPedidos: [],
        tareasCorte: [],
        tareasConfeccion: [],
        tareasPreparado: [],
        timer: "",
        countDown: 90,
        allReports: [],      
        tooltipVisible: [],
        datosProduccion: [],
        festivosElche: [], // Set de fechas 'YYYY-MM-DD' del calendario "Elche" más reciente
        produccionInfoOriginal: {},
        abriendoProduccion: false,
        produccionInfo:{
          id: 0,
          producto: "",
          pedido: "",
          desglosePedido: [],
          unidades: 0,
          fechaInicio: "",
          fechaFin: "",
          dias: 0,
          horas: 0,
          productividad: 0,
          tiempos: {
            corte: [{informacion: "", fechaInicio: "", fechaFin: "", horaInicio: "07:00", horaFin: "15:00", empleados: "", horasTotales: "", productividad: ""}],
            mano: [{informacion: "", fechaInicio: "", fechaFin: "", horaInicio: "07:00", horaFin: "15:00", empleados: "", horasTotales: "", productividad: ""}],
            aparado: [{informacion: "", fechaInicio: "", fechaFin: "", horaInicio: "07:00", horaFin: "15:00", empleados: "", horasTotales: "", productividad: ""}],
          },
          correciones: [],
          timeline: [],
          observaciones: "",
          visible: true,
        },
        produccionPrint:{
          id: 0,
          producto: "",
          pedido: "",
          desglosePedido: [],
          unidades: 0,
          fechaInicio: "",
          fechaFin: "",
          dias: 0,
          horas: 0,
          productividad: 0,
          tiempos: {
            corte: [{informacion: "", fechaInicio: "", fechaFin: "", horaInicio: "", horaFin: "", empleados: "", horasTotales: "", productividad: ""}],
            mano: [{informacion: "", fechaInicio: "", fechaFin: "", horaInicio: "", horaFin: "", empleados: "", horasTotales: "", productividad: ""}],
            aparado: [{informacion: "", fechaInicio: "", fechaFin: "", horaInicio: "", horaFin: "", empleados: "", horasTotales: "", productividad: ""}],
          },
          correciones: [{texto: "", solucionado: false}],
          timeline: [{texto: "", fecha: ""}],
          observaciones: "",
          visible: false,
          pedidoInfo: {listaSku:[]},
          timerAutoSave: null,
          prevProduccionInfo: null,

        },
        listadoProductosTitulos: [],
        buscarProduccion: '',
        buscarProduccionVisibles: {'text':'Activos'},

      }
    },
    computed: {
      formartedItems () {
        return this.datosProduccion.filter(item => {
            const esActivo = item.visible == 1;
            const esArchivado = item.visible == 0;

            // Filtrar por visibilidad
            if (this.buscarProduccionVisibles.text === 'Activos' && !esActivo) {
              return false;
            }
            if (this.buscarProduccionVisibles.text === 'Archivados' && !esArchivado) {
              return false;
            }

            // Filtrar por nombre de producto (puede venir vacio o null)
            return String(item.producto || '').toLowerCase().includes(this.buscarProduccion.toLowerCase());
          });
      }

    },
    methods:{
      guardarProduccion(){
        clearTimeout(this.timerAutoSave);
        this.saveProduccion(false); 
      },
      toggleTooltip(index) {
        this.$set(this.tooltipVisible, index, !this.tooltipVisible[index]);
      },
      async loadItems(autoload = false){
        try {

          axios.post("/uso", {seccion:"gestionarDia"});

            //const responseProduccionTitulos = await axios.get("/taller/produccion/titulos");

            /*if(!autoload)
            {
              const responeProducts = await axios.get("/articulos/shopify");
              this.listadoProductosTitulos = responeProducts.data;
            }

            const responseReportes = await axios.get("/taller/reportes");
            const resReportes = responseReportes.data;

            const responsePendientes = await axios.get("/taller/pedidos/pendientes");
            let aux = responsePendientes.data;

            const responsePiezas = await axios.get("/taller/pedidos/piezas");
            const resPiezas = responsePiezas.data;

            const responseCorteDia = await axios.get("/taller/master/corte/dia");
            const resCorteDia = responseCorteDia.data;

            const responseConfeccionDia = await axios.get("/taller/master/confeccion/dia");
            const resConfeccionDia = responseConfeccionDia.data;

            const responsePreparadoDia = await axios.get("/taller/master/preparado/dia");
            const resPreparadoDia = responsePreparadoDia.data;

            const responseProduccion = await axios.get("/taller/produccion/all");
            this.datosProduccion = responseProduccion.data;*/

            //console.log('1');
            if (!autoload) {
              const responeProducts = await axios.get("/articulos/shopify");
              // Solo los titulos (strings): el v-select de producto guarda un string,
              // mezclar objetos y strings rompia la seleccion al editar
              this.listadoProductosTitulos = Array.from(new Set(
                responeProducts.data.map(p => p.title).filter(Boolean)
              )).sort();
            }

            //console.log('2');
            // Lanzamos todas las peticiones a la vez
            const [
              responseReportes,
              responsePendientes,
              responsePiezas,
              responseCorteDia,
              responseConfeccionDia,
              responsePreparadoDia,
              responseProduccion
            ] = await Promise.all([
              axios.get("/taller/reportes"),
              axios.get("/taller/pedidos/pendientes"),
              axios.get("/taller/pedidos/piezas"),
              axios.get("/taller/master/corte/dia"),
              axios.get("/taller/master/confeccion/dia"),
              axios.get("/taller/master/preparado/dia"),
              axios.get("/taller/produccion/all")
            ]);

            // Cargar festivos del calendario "Elche" más reciente (solo cuando aún no se cargó)
            if (this.festivosElche.length === 0) {
              try {
                const responseCalendarios = await axios.get("/vacaciones/calendarios");
                // El backend ya los devuelve ORDER BY anio DESC; cogemos el primero que contenga "Elche"
                const calendarioElche = (responseCalendarios.data || []).find(c =>
                  c.nombre && c.nombre.toLowerCase().includes("elche")
                );
                if (calendarioElche) {
                  const responseFestivos = await axios.get(`/vacaciones/calendarios/${calendarioElche.id}/festivos`);
                  this.festivosElche = (responseFestivos.data || []).map(f => {
                    // Normalizar a 'YYYY-MM-DD' (la fecha llega como ISO o como Date string)
                    const d = new Date(f.fecha);
                    const yyyy = d.getFullYear();
                    const mm = String(d.getMonth() + 1).padStart(2, "0");
                    const dd = String(d.getDate()).padStart(2, "0");
                    return `${yyyy}-${mm}-${dd}`;
                  });
                }
              } catch (errFestivos) {
                console.error("No se pudieron cargar los festivos de Elche", errFestivos);
              }
            }

            //console.log('3');

            // Procesamos todas las respuestas
            const resReportes = responseReportes.data;
            let aux = responsePendientes.data;
            const resPiezas = responsePiezas.data;
            const resCorteDia = responseCorteDia.data;
            const resConfeccionDia = responseConfeccionDia.data;
            const resPreparadoDia = responsePreparadoDia.data;
            this.datosProduccion = responseProduccion.data;

            //console.log('4');


            this.datosProduccion = this.datosProduccion.reverse();

            this.datosProduccion = this.datosProduccion.map(item => {
                item.correcionesTotales = item.correciones.filter(correccion => correccion.texto.length > 0).length;
                item.correcionesResueltas = item.correciones.filter(correccion => correccion.solucionado == true).length;
              return item;
            });

            //console.log(this.datosProduccion);

            const responseAllPedidos = await axios.get("/taller/pedidos");
            this.allPedidos = responseAllPedidos.data;

            this.allPedidos = this.allPedidos.map(pedido => {
              pedido.listaSku = JSON.parse(pedido.listaSku );
              return pedido;
            });

            this.tareasCorte = [];
            this.tareasConfeccion = [];
            this.tareasPreparado = [];

            let idsPedido = [];
            idsPedido = resConfeccionDia.map(element => element.idPedido);
            idsPedido = idsPedido.filter((id, index) => idsPedido.indexOf(id) === index);

            const responeTareas = await axios.post("/taller/master/tareas/pedido", {list: [...new Set(idsPedido)] });
            const resTareas = responeTareas.data;

            aux = aux.reverse();

            aux.forEach(sku => {

              sku.proceso = false;
              sku.corteDisponible = true;
              sku.manoDisponible = true;
              sku.preparadoDisponible = true;
              let totalNumCortePiel = 0;
              let totalNumCorteForros = 0;
              let totalNumCorteRefuerzos = 0;
              let numCortePiel = 0;
              let numCorteForros = 0;
              let numCorteRefuerzos = 0;

              resPiezas.forEach(pieza => {
                if (sku.pedido === pieza.idPedido && sku.sku === `${pieza.sku}-${pieza.color}`) {
                  switch (pieza.categoria) {
                    case "Piel":
                      totalNumCortePiel += pieza.cantidad;
                      numCortePiel += pieza.terminado;
                      break;
                    case "Forros":
                      totalNumCorteForros += pieza.cantidad;
                      numCorteForros += pieza.terminado;
                      break;
                    case "Refuerzos":
                      totalNumCorteRefuerzos += pieza.cantidad;
                      numCorteRefuerzos += pieza.terminado;
                      break;
                  }
                }
              });

              sku.totalNumCortePiel = totalNumCortePiel;
              sku.totalNumCorteForros = totalNumCorteForros;
              sku.totalNumCorteRefuerzos = totalNumCorteRefuerzos;

              sku.cortePiel = totalNumCortePiel - numCortePiel;
              sku.corteForros = totalNumCorteForros - numCorteForros;
              sku.corteRefuerzos = totalNumCorteRefuerzos - numCorteRefuerzos;

              if(numCortePiel > 0 || numCorteForros > 0 || numCorteRefuerzos > 0)
              {
                sku.proceso = true;
              }

              resCorteDia.forEach(corteDia => {
                if(corteDia.idPedido == sku.pedido && corteDia.sku == sku.sku)
                { 
                  sku.corteDisponible = false;
                  sku.paso = corteDia.paso;
                  sku.idCorteDia = corteDia.id;
                  this.tareasCorte.push(sku)
                }
              })

              resConfeccionDia.forEach(confeccionDia => {
                if(confeccionDia.idPedido == sku.pedido && confeccionDia.sku == sku.sku)
                { 
                  sku.manoDisponible = false;
                  sku.paso = confeccionDia.paso;
                  sku.idConfeccionDia = confeccionDia.id;
                  sku.idPedido = confeccionDia.idPedido;
                  this.tareasConfeccion.push(sku);
                }
              })

              resPreparadoDia.forEach(preparadoDia => {
                if(preparadoDia.idPedido == sku.pedido && preparadoDia.sku == sku.sku)
                {
                  sku.preparadoDisponible = false;
                  sku.paso = preparadoDia.paso;
                  sku.idPreparadoDia = preparadoDia.id;
                  this.tareasPreparado.push(sku);
                }
              })

            });

            this.skuPedidos = aux.filter(item => item.visible == 1);

            this.skuPedidos.forEach((objeto, index) => {
              objeto.index = index + 1;
              objeto.show = false;
            });

            this.tareasCorte = this.tareasCorte.sort((a, b) => Number(a.paso) - Number(b.paso));

            this.tareasConfeccion = this.tareasConfeccion.sort((a, b) => Number(a.paso) - Number(b.paso));

            this.tareasConfeccion.forEach(confeccion => {
              const finalizado = resTareas
                .filter(item => item.idPedido == confeccion.idPedido)
                .every(pieza => pieza.terminado > 0);


                if(finalizado)                
                  confeccion.completados = confeccion.cantidad;

            });    

            let auxReports = [];

            resReportes.forEach(report => {
              this.tareasCorte.forEach(tarea => {
                if(tarea.sku == `${report.sku}-${report.color}` && tarea.pedido == report.idPedido && report.solucionado == false)
                {
                  auxReports.push(report);
                }
                
              });

              this.tareasConfeccion.forEach(tarea => {
                if(tarea.sku == `${report.sku}-${report.color}` && tarea.pedido == report.idPedido && report.solucionado == false)
                {
                  auxReports.push(report);
                }
                
              });
              
            });

            this.allReports = auxReports;

        } catch (error) {
            console.log(error);
        }
      },
      addToPreparado(data){

        let info = {idPedido: data.pedido, sku: data.sku, fecha: "", paso: this.tareasPreparado.length+1, titulo: data.titulo}

        data.paso = info.paso;

          axios
            .post("/taller/master/preparado/dia", info)
            .then(response => {
                return response.data;
            })
            .then(res => {

              data.idPreparadoDia = res.insertId;
              data.preparadoDisponible = false;
              this.tareasPreparado.push(data);
              this.$refs.tablePedidos.refresh();

            });
      },
      addToCorte(data){

        let info = {idPedido: data.pedido, sku: data.sku, fecha: "", paso: this.tareasCorte.length+1, titulo: data.titulo}

        data.paso = info.paso;

          axios
            .post("/taller/master/corte/dia", info)
            .then(response => {
                return response.data;
            })
            .then(res => {

              data.idCorteDia = res.insertId;
              data.corteDisponible = false;
              this.tareasCorte.push(data);
              this.$refs.tablePedidos.refresh();

              /*this.$swal({
                icon: 'success',
                title: 'Corte',
                text: 'El sku se ha pasado a corte.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })*/
            });
      },
      delToCorte(data)
      {

        let info = {idCorteDia: data.idCorteDia}

          axios
            .delete("/taller/master/corte/dia",{data: info})
            .then(response => {
                return response.data;
            })
            .then(res => {

              let elemento = this.skuPedidos.find(item => item === data);
              elemento.corteDisponible = true;
              this.$refs.tablePedidos.refresh();

              let indice = this.tareasCorte.findIndex(item => item.idCorteDia == data.idCorteDia);
              this.tareasCorte.splice(indice, 1)

              this.updatePasoCorte();
            });
      },
      getStyleStatus(data, column){

        if(column == "piel")
        {
          if(data.cortePiel == 0)
            return "corte-completado"
          else if(data.cortePiel != data.totalNumCortePiel)
            return "corte-proceso"
        }
        else if(column == "forros")
        {
          if(data.corteForros == 0)
            return "corte-completado"
          else if(data.corteForros  != data.totalNumCorteForros)
            return "corte-proceso"
        }
        else if(column == "refuerzos")
        {
          if(data.corteRefuerzos == 0)
            return "corte-completado"
          else if(data.corteRefuerzos  != data.totalNumCorteRefuerzos)
            return "corte-proceso"
        }

        return "";
      },
      moveCorte(data, moveUp) {
        const index = this.tareasCorte.findIndex(obj => obj.idCorteDia === data.idCorteDia);

        if (moveUp && index > 0) {
            const temp = this.tareasCorte[index];
            this.tareasCorte[index] = this.tareasCorte[index - 1];
            this.tareasCorte[index - 1] = temp;
        } else if (!moveUp && index < this.tareasCorte.length - 1) {
            const temp = this.tareasCorte[index];
            this.tareasCorte[index] = this.tareasCorte[index + 1];
            this.tareasCorte[index + 1] = temp;
        }

        this.updatePasoCorte();
      },
      updatePasoCorte()
      {
        this.tareasCorte.forEach((element, index) => {
            element.paso = index + 1;
        });

        this.tareasCorte = this.tareasCorte.sort((a, b) => Number(a.paso) - Number(b.paso));

        let dataOrden = this.tareasCorte.map(corte => {
            return {
              idCorteDia: corte.idCorteDia,
              paso: corte.paso
            };
        });

        axios
            .put("/taller/master/corte/dia/sort", {data: dataOrden})
            .then(response => {
                return response.data;
            })
            .then(res => {
            });
      },
      addToConfeccion(data){

        let info = {idPedido: data.pedido, sku: data.sku, fecha: "", paso: this.tareasConfeccion.length+1, titulo: data.titulo}

        data.paso = info.paso;

          axios
            .post("/taller/master/confeccion/dia", info)
            .then(response => {
                return response.data;
            })
            .then(res => {

              data.idConfeccionDia = res.insertId;
              data.manoDisponible = false;
              this.tareasConfeccion.push(data);
              this.$refs.tablePedidos.refresh();

            });
      },
      delToConfeccion(data)
      {

        let info = {idConfeccionDia: data.idConfeccionDia}

          axios
            .delete("/taller/master/confeccion/dia",{data: info})
            .then(response => {
                return response.data;
            })
            .then(res => {

              let elemento = this.skuPedidos.find(item => item === data);
              elemento.manoDisponible = true;
              this.$refs.tablePedidos.refresh();

              let indice = this.tareasConfeccion.findIndex(item => item.idConfeccionDia == data.idConfeccionDia);
              this.tareasConfeccion.splice(indice, 1)

              this.updatePasoConfeccion();
            });
      },
      delToPreparado(data)
      {

        let info = {idPreparadoDia: data.idPreparadoDia}

          axios
            .delete("/taller/master/preparado/dia",{data: info})
            .then(response => {
                return response.data;
            })
            .then(res => {

              let elemento = this.skuPedidos.find(item => item === data);
              elemento.preparadoDisponible = true;
              this.$refs.tablePedidos.refresh();

              let indice = this.tareasPreparado.findIndex(item => item.idPreparadoDia == data.idPreparadoDia);
              this.tareasPreparado.splice(indice, 1)

              this.updatePasoPreparado();
            });
      },
      addToArchivar(data){

        axios
          .post("/taller/pedidos/archivar", {id: data.pedido, archivado: 1})
          .then(response => {
              return response.data;
          })
          .then(res => {
            this.$swal({
                  icon: 'success',
                  title: 'El pedido ' + data.refPedido+' se ha archivado correctamente, actualizando el listado...',
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
              })

            this.loadItems();
          });
      },
      movePreparado(data, moveUp) {
        const index = this.tareasPreparado.findIndex(obj => obj.idPreparadoDia === data.idPreparadoDia);

        if (moveUp && index > 0) {
            const temp = this.tareasPreparado[index];
            this.tareasPreparado[index] = this.tareasPreparado[index - 1];
            this.tareasPreparado[index - 1] = temp;
        } else if (!moveUp && index < this.tareasPreparado.length - 1) {
            const temp = this.tareasPreparado[index];
            this.tareasPreparado[index] = this.tareasPreparado[index + 1];
            this.tareasPreparado[index + 1] = temp;
        }

        this.updatePasoPreparado();
      },
      updatePasoPreparado()
      {
        this.tareasPreparado.forEach((element, index) => {
            element.paso = index + 1;
        });

        this.tareasPreparado = this.tareasPreparado.sort((a, b) => Number(a.paso) - Number(b.paso));

        let dataOrden = this.tareasPreparado.map(dato => {
            return {
              idPreparadoDia: dato.idPreparadoDia,
              paso: dato.paso
            };
        });

        axios
            .put("/taller/master/preparado/dia/sort", {data: dataOrden})
            .then(response => {
                return response.data;
            })
            .then(res => {
            });
      },
      moveConfeccion(data, moveUp) {
        const index = this.tareasConfeccion.findIndex(obj => obj.idConfeccionDia === data.idConfeccionDia);

        if (moveUp && index > 0) {
            const temp = this.tareasConfeccion[index];
            this.tareasConfeccion[index] = this.tareasConfeccion[index - 1];
            this.tareasConfeccion[index - 1] = temp;
        } else if (!moveUp && index < this.tareasConfeccion.length - 1) {
            const temp = this.tareasConfeccion[index];
            this.tareasConfeccion[index] = this.tareasConfeccion[index + 1];
            this.tareasConfeccion[index + 1] = temp;
        }

        this.updatePasoConfeccion();
      },
      updatePasoConfeccion()
      {
        this.tareasConfeccion.forEach((element, index) => {
            element.paso = index + 1;
        });

        this.tareasConfeccion = this.tareasConfeccion.sort((a, b) => Number(a.paso) - Number(b.paso));

        let dataOrden = this.tareasConfeccion.map(dato => {
            return {
              idConfeccionDia: dato.idConfeccionDia,
              paso: dato.paso
            };
        });

        axios
            .put("/taller/master/confeccion/dia/sort", {data: dataOrden})
            .then(response => {
                return response.data;
            })
            .then(res => {
            });
      },
      reportSolucionado(data){
        
         axios
            .post("/taller/reporte/solucionado/"+data.id)
            .then(response => {
                return response.data;
            })
            .then(res => {

              this.allReports = this.allReports.filter(obj => obj.id !== data.id);

            });
      },
      rowClass(item) {
        if (item.cortePiel == 0 && item.corteForros == 0 && item.corteRefuerzos == 0) {
          return 'bg-finish-color';
        }

        return '';
      },
      rowClassPreparado(item) {
        
        return '';
      },
      openModalProduccion(){
        this.produccionInfo = {
          id: 0,
          producto: "",
          pedido: "",
          unidades: 0,
          fechaInicio: "",
          fechaFin: "",
          dias: 0,
          horas: 0,
          productividad: 0,
          desglosePedido: [],
          tiempos: {
            corte: [{informacion: "", fechaInicio: "", fechaFin: "", horaInicio: "07:00", horaFin: "15:00", empleados: "", horasTotales: "", productividad: ""}],
            mano: [{informacion: "", fechaInicio: "", fechaFin: "", horaInicio: "07:00", horaFin: "15:00", empleados: "", horasTotales: "", productividad: ""}],
            aparado: [{informacion: "", fechaInicio: "", fechaFin: "", horaInicio: "07:00", horaFin: "15:00", empleados: "", horasTotales: "", productividad: ""}],
          },
          correciones: [{texto: "", solucionado: false}],
          timeline: [{texto: "", fecha: ""}],
          observaciones: "",
          visible: false,
        },

        this.produccionInfoOriginal = "";

        this.$bvModal.show('modal-produccion');
      },
      editarProduccion(data){
        // Clon para no mutar la fila de la tabla en vivo; el flag evita que el
        // watcher de "pedido" recalcule (y machaque) unidades al abrir el modal
        this.abriendoProduccion = true;
        this.produccionInfo = JSON.parse(JSON.stringify(data));
        this.produccionInfoOriginal = JSON.parse(JSON.stringify(data));
        this.$bvModal.show('modal-produccion');
        this.$nextTick(() => { this.abriendoProduccion = false; });
      },
      addProduccionCorte(){
        this.produccionInfo.tiempos.corte.push({fechaInicio: "", fechaFin: "",horaInicio: "07:00", horaFin: "15:00", empleados: "", horasTotales: "", productividad: ""});
      },
      addProduccionMano(){
        this.produccionInfo.tiempos.mano.push({fechaInicio: "", fechaFin: "", horaInicio: "07:00", horaFin: "15:00", empleados: "", horasTotales: "", productividad: ""});
      },
      addProduccionAparado(){
        this.produccionInfo.tiempos.aparado.push({fechaInicio: "", fechaFin: "", horaInicio: "07:00", horaFin: "15:00", empleados: "", horasTotales: "", productividad: ""});
      },
      addProduccionCorrecion(){
        this.produccionInfo.correciones.push({texto: "", solucionado: false});
      },
      addProduccionTimeline(){
        let fecha = new Date();
        this.produccionInfo.timeline.push({texto: "", fecha: fecha.toISOString().split('T')[0]});
        //this.produccionInfo.timeline.push({texto: "", fecha: ""});
      },
      addProducto(){
        this.produccionInfo.desglosePedido.push({texto: "", cantidad: 0});
      },
      delProduccionCorte(index){
        this.produccionInfo.tiempos.corte.splice(index, 1);
      },
      delDesglosePedido(index){
        this.produccionInfo.desglosePedido.splice(index, 1);
      },
      delProduccionMano(index){
        this.produccionInfo.tiempos.mano.splice(index, 1);
      },
      delProduccionAparado(index){
        this.produccionInfo.tiempos.aparado.splice(index, 1);
      },
      delProduccionCorrecion(index){
        this.produccionInfo.correciones.splice(index, 1);
      },
      delProduccionTimeline(index){
        this.produccionInfo.timeline.splice(index, 1);
      },
      saveProduccion(autoclose = true){

        if(!autoclose && this.produccionInfo.id == 0)
          return;

        // Normalizar producto: null (select limpiado) -> "", objeto antiguo -> su title.
        // Sin esto, un producto null rompia el guardado en silencio.
        if(this.produccionInfo.producto == null)
        {
          this.produccionInfo.producto = "";
        }
        else if(this.produccionInfo.producto.title != undefined)
        {
          this.produccionInfo.producto = this.produccionInfo.producto.title;
        }

        if (autoclose || JSON.stringify(this.produccionInfo) !== JSON.stringify(this.produccionInfoOriginal)) {

          //console.log('guardando');
          if(this.produccionInfo.id == 0)
          {
            axios
            .post("/taller/produccion", this.produccionInfo)
            .then(response => {
                return response.data;
            })
            .then(res => {
              this.produccionInfo.id = res.insertId;

              this.datosProduccion.unshift(this.produccionInfo);
              if(autoclose)
                this.$bvModal.hide('modal-produccion');
            });
          }
          else
          {
            axios
            .put("/taller/produccion", this.produccionInfo)
            .then(response => {
                return response.data;
            })
            .then(res => {
              if(autoclose)
                this.$bvModal.hide('modal-produccion');
            });
          }
        }
        
      },
      imprimirProduccion(item) {
        this.produccionPrint = item;
        
        try{
          this.produccionPrint.pedidoInfo = this.allPedidos.find(pedido => pedido.referencia == item.pedido);

          if(this.produccionPrint.pedidoInfo != undefined)
            this.produccionPrint.pedidoInfo.listaSku = JSON.parse(this.produccionPrint.pedidoInfo.listaSku);
          else
          {
            this.produccionPrint.pedidoInfo = {listaSku: []};
          }


          if(this.produccionPrint.pedido == ""){
            this.produccionPrint.pedidoInfo.listaSku = this.produccionPrint.desglosePedido.map(item => {
              return {sku: item.texto, cantidad: item.cantidad}
            });
          }
          
        }
        catch(e)
        {
          this.produccionPrint.pedidoInfo = {listaSku: []};
        }

        if (this.produccionPrint.pedido == null || this.produccionPrint.pedido == "null")
          this.produccionPrint.pedido = '';

        let self = this;
        setTimeout(function(){ 

          const contenido = self.$refs.contenidoParaImprimir.innerHTML;
          const ventana = window.open("", "", "width=800,height=600");

          ventana.document.write(`
            <html>
              <head>
                <title>Impresión</title>
                <style>
                table th, table td {
                    text-align: center; /* Centrar el texto */
                }

                .invoice-container {
                  margin: 10px;
                  font-family: 'Arial', sans-serif;
                  color: #333;
                  line-height: 1.6;
                }

                /* Títulos */
                .invoice-title {
                  text-align: center;
                  font-size: 22px;
                  font-weight: bold;
                  margin-bottom: 20px;
                }

                /* Secciones */
                .section {
                  margin-bottom: 20px;
                }

                h2 {
                  font-size: 18px;
                  color: #444;
                  border-bottom: 2px solid #ddd;
                  padding-bottom: 5px;
                  margin-bottom: 10px;
                }

                .timeline-date {
                  font-weight: bold;
                  /*color: #007bff;*/
                }

                /* Impresión */
                @media print {
                  .page-break {
                    page-break-before: always;
                  }

                  .invoice-container {
                    margin: 10mm; /* Márgenes en milímetros */
                  }

                  h2 {
                    color: black;
                  }
                }
                  @media print {
                    
                    .page-break {
                      page-break-before: always; /* Hace que esta sección comience en una nueva página */
                    }

                     @page {
                        size: A4 landscape;
                        margin: 10mm;
                      }

                      body {
                        width: 297mm;  /* A4 en horizontal */
                        height: 210mm; /* A4 en horizontal */
                      }
                  }
                </style>
              </head>
              <body>${contenido}</body>
            </html>
          `);
        
          ventana.document.close();
          ventana.print();
          ventana.close();

         }, 200);

      
      },
      archivarProduccion(item){

        axios
          .put("/taller/produccion/archivar", {id: item.id})
          .then(response => {
              return response.data;
          })
          .then(res => {
            item.visible = 0;
          });
      },
      desarchivarProduccion(item){

        axios
          .put("/taller/produccion/desarchivar", {id: item.id})
          .then(response => {
              return response.data;
          })
          .then(res => {
            item.visible = 1;
          });
      },
      borrarProduccion(item){

        this.$swal({
          title: 'Estas seguro que quieres borrar la produccion: ' + item.producto + '\n\nEsta accion no se puede deshacer.',
          icon: 'error',
          showCancelButton: true,
          //html: `<input type="text" id="motivo" class="swal2-input" placeholder="Motivo">`,
          confirmButtonText: 'Si, borrar',
          cancelButtonText: 'No',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {

          if(result.isConfirmed)
          {
            axios
              .delete(`/taller/produccion/${item.id}`)
              .then(response => {
                  return response.data;
              })
              .then(res => {
                this.datosProduccion = this.datosProduccion.filter(itemFilter => itemFilter.id != item.id);
              });

          }

        });

       
      },
      formatearFecha(fecha) {
        if (!fecha) return "";
        const opciones = { weekday: "long", day: "numeric", month: "long", year: "numeric" };
        return new Date(fecha).toLocaleDateString("es-ES", opciones).toUpperCase();
      },    
      formatearFechaCorta(fecha) {
        if (!fecha) return "";
        const opciones = { weekday: "long", day: "numeric", month: "numeric", year: "numeric" };
        return new Date(fecha).toLocaleDateString("es-ES", opciones).toUpperCase();
      }
    },
    watch: {
      produccionInfo: {
        handler(va) {                    
          const festivosSet = new Set(this.festivosElche || []);
          const toYMD = (d) => {
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const dd = String(d.getDate()).padStart(2, "0");
            return `${yyyy}-${mm}-${dd}`;
          };

          //Tareas calcula horas
          function calcularHorasTotales(obj, festivos) {
              let { fechaInicio, fechaFin, horaInicio, horaFin, empleados } = obj;

              let inicio = new Date(`${fechaInicio}T${horaInicio}:00`);
              let fin = new Date(`${fechaFin}T${horaFin}:00`);

              if (inicio > fin) {
                  //console.error("Error: fechaInicio es posterior a fechaFin");
                  return null;
              }

              let horasTotales = 0;
              let current = new Date(inicio);

              while (current <= fin) {
                  let diaSemana = current.getDay(); // 0 = Domingo, 1 = Lunes, ..., 6 = Sábado
                  let esFestivo = festivos && festivos.has(toYMD(current));

                  if (diaSemana >= 1 && diaSemana <= 5 && !esFestivo) { // Solo lunes a viernes y excluyendo festivos
                      let esPrimerDia = current.toDateString() === inicio.toDateString();
                      let esUltimoDia = current.toDateString() === fin.toDateString();

                      let horaInicioDia = esPrimerDia ? inicio.getHours() + inicio.getMinutes() / 60 : 7;
                      let horaFinDia = esUltimoDia ? fin.getHours() + fin.getMinutes() / 60 : 15;

                      if (horaInicioDia < horaFinDia) {
                          horasTotales += horaFinDia - horaInicioDia;
                      }
                  }

                  // Pasar al siguiente día
                  current.setDate(current.getDate() + 1);
                  current.setHours(0, 0, 0, 0); // Reiniciar a medianoche
              }

              horasTotales = Math.round(horasTotales * empleados * 100) / 100;
              return isNaN(horasTotales) ? 0 : horasTotales;
          }


          let horasTotales = 0;

          this.produccionInfo.tiempos.corte.forEach(dato => {
            dato.horasTotales = calcularHorasTotales(dato, festivosSet);
            horasTotales += dato.horasTotales;
          });

          this.produccionInfo.tiempos.mano.forEach(dato => {
            dato.horasTotales = calcularHorasTotales(dato, festivosSet);
            horasTotales += dato.horasTotales;
          });

          this.produccionInfo.tiempos.aparado.forEach(dato => {
            dato.horasTotales = calcularHorasTotales(dato, festivosSet);
            horasTotales += dato.horasTotales;
          });
                    
          this.produccionInfo.horas = horasTotales.toFixed(2);

          //Calcular dias totales
          function contarDiasHabiles(fechaInicio, fechaFin, festivos) {
              let inicio = new Date(fechaInicio);
              let fin = new Date(fechaFin);

              if (inicio > fin) {
                  console.error("Error: fechaInicio es posterior a fechaFin");
                  return null;
              }

              let diasHabiles = 0;
              let current = new Date(inicio);

              while (current <= fin) {
                  let diaSemana = current.getDay(); // 0 = Domingo, 1 = Lunes, ..., 6 = Sábado
                  let esFestivo = festivos && festivos.has(toYMD(current));
                  if (diaSemana >= 1 && diaSemana <= 5 && !esFestivo) { // Solo lunes a viernes y excluyendo festivos
                      diasHabiles++;
                  }
                  current.setDate(current.getDate() + 1);
              }

              return diasHabiles;
          }

          this.produccionInfo.dias = contarDiasHabiles(this.produccionInfo.fechaInicio, this.produccionInfo.fechaFin, festivosSet);

          //Ordenar timeline por fecha
          //this.produccionInfo.timeline = this.produccionInfo.timeline.sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

          //Correciones
          this.produccionInfo.correcionesTotales = this.produccionInfo.correciones.filter(correccion => correccion.texto.length > 0).length;
          this.produccionInfo.correcionesResueltas = this.produccionInfo.correciones.filter(correccion => correccion.solucionado == true).length;      
          
          this.datosProduccion = this.datosProduccion.map(item => {
            if(item.id == this.produccionInfo.id)
            {
              item = this.produccionInfo;
            }
            return item;
          });

          //Autosave
          if (this.timerAutoSave) {
                clearTimeout(this.timerAutoSave);
          }

          this.timerAutoSave = setTimeout(() => {
            this.saveProduccion(false); 
          }, 60000);
        },
        deep: true,
      },
      "produccionInfo.horas":function (newVal, oldVal){

        this.produccionInfo.productividad = Math.round((this.produccionInfo.unidades / this.produccionInfo.horas) * 100) / 100;

        if(isNaN(this.produccionInfo.productividad))
          this.produccionInfo.productividad = 0;
      },
      "produccionInfo.timeline":function (newVal, oldVal){
        let sortedTimeline = newVal.slice().sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
    
          // Solo actualizar si el array realmente cambió
          if (JSON.stringify(sortedTimeline) !== JSON.stringify(this.produccionInfo.timeline)) {
              this.produccionInfo.timeline = sortedTimeline;
          }

      },
      "produccionInfo.pedido":function (newVal, oldVal){
        // Solo recalcular cuando el usuario cambia el pedido, no al abrir el modal
        if (this.abriendoProduccion) return;

        //Pedido
        let pedido = this.allPedidos.find(pedido => pedido.referencia == this.produccionInfo.pedido);

        // Si la referencia no casa (pedido antiguo, guion distinto, lista sin cargar),
        // no tocar las unidades guardadas
        if (pedido == undefined) return;

        let cantidad = 0;
        pedido.listaSku.forEach(sku => {
          cantidad += parseInt(sku.cantidad) || 0;
        });

        this.produccionInfo.producto = pedido.listaSku[0].titulo;
        this.produccionInfo.unidades = cantidad;
      }

    },
    mounted() {
      this.loadItems();    
    }, 
    beforeDestroy() {
      clearInterval(this.timer);
    },
    created(){

      this.timer = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown -= 1;
        } else {
            this.loadItems(true);
            this.countDown = 90;
        }
      }, 1000);

    }
  }
</script>

<style lang="scss">
  @import '../@core/scss/vue/libs/vue-select.scss';

  .invoice-preview{
    display: none;
  }

  .btn-circle{
    border-radius: 20px;
    padding: 12px;
    margin-right: 10px;
  }

  .bg-finish-color {
    background-color: rgba(144, 238, 144, 0.61) !important;
    font-weight: bolder;
  }

  .bg-proceso-color{
    background-color: #ff9e43a2 !important;
    color: white;
    font-weight: bolder;
  }

  .corte-completado{
    background-color: rgba(144, 238, 144, 0.61);
    border-radius: 50%;
    padding: 10px;
  }

  .corte-proceso{
    background-color: #ff9e43a2 !important;
    border-radius: 50%;
    padding: 10px;
  }

  .collapse-title{
    font-size: 20px !important;
  }

  .area-card .card-header{
    padding: 10px !important;
  }

  // Bordes laterales de color por sección
  .border-left-primary { border-left: 3px solid #7367f0 !important; }
  .border-left-info { border-left: 3px solid #00cfe8 !important; }
  .border-left-danger { border-left: 3px solid #ea5455 !important; }
  .border-left-warning { border-left: 3px solid #ff9f43 !important; }
  .border-left-secondary { border-left: 3px solid #82868b !important; }
  .border-left-success { border-left: 3px solid #28c76f !important; }

  // Header de sección
  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-right: 1.5rem;
    cursor: pointer;
  }

  // Estado vacío
  .empty-state {
    text-align: center;
    padding: 2rem 0;
    color: #b9b9c3;
  }
  .empty-state i { font-size: 2rem; margin-bottom: 0.5rem; }

</style>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap');

// ══════════════════════════════════════════════════════════════
// GESTIONAR TALLER — same tokens as /pedido-taller-vero/fabricando
// ══════════════════════════════════════════════════════════════

$gt-bg:        #F8FAFC;
$gt-surface:   #FFFFFF;
$gt-surface-2: #F1F5F9;
$gt-border:    #E2E8F0;
$gt-divider:   #EEF2F7;
$gt-ink:       #1E293B;
$gt-text:      #1E293B;
$gt-mute:      #64748B;
$gt-soft:      #94A3B8;
$gt-primary:   #3B82F6;
$gt-cta:       #F97316;
$gt-emerald:   #10B981;
$gt-coral:     #EF4444;
$gt-amber:     #F59E0B;
$gt-cyan:      #06B6D4;
$gt-violet:    #8B5CF6;

.gt {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  background: $gt-bg;
  color: $gt-text;
  margin: -2rem;
  padding: 28px 32px 56px;
  min-height: calc(100vh - 4rem);
  font-feature-settings: "tnum", "zero";

  *, *::before, *::after { box-sizing: border-box; }

  // ──────────── HEADER CARD ────────────
  .gt-dash-header {
    background: $gt-surface;
    border: 1px solid $gt-border;
    border-radius: 14px;
    padding: 18px 20px 16px;
    margin-bottom: 18px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  }

  .gt-dash-header-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    flex-wrap: wrap;
  }

  .gt-eyebrow {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    color: $gt-primary;
    letter-spacing: 0.14em;
    margin-bottom: 4px;

    &::before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      background: $gt-cta;
      border-radius: 50%;
      margin-right: 6px;
      vertical-align: middle;
      animation: gt-pulse 2s infinite;
    }
  }

  .gt-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 22px;
    font-weight: 700;
    color: $gt-ink;
    line-height: 1.1;
    letter-spacing: -0.01em;
    margin: 0;
  }

  .gt-header-actions {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
  }

  .gt-stat-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 38px;
    padding: 0 14px;
    background: $gt-bg;
    border: 1px solid $gt-border;
    border-radius: 8px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: $gt-mute;

    i { font-size: 12px; }
    strong {
      font-family: 'JetBrains Mono', monospace;
      font-size: 13px;
      font-weight: 700;
      font-feature-settings: "tnum";
    }

    &--primary   { i { color: $gt-primary; } strong { color: $gt-ink; } }
    &--info {
      background: rgba(6, 182, 212, 0.06);
      border-color: rgba(6, 182, 212, 0.2);
      i { color: $gt-cyan; } strong { color: darken($gt-cyan, 8%); }
    }
    &--danger {
      background: rgba(239, 68, 68, 0.06);
      border-color: rgba(239, 68, 68, 0.2);
      i { color: $gt-coral; } strong { color: $gt-coral; }
    }
    &--warning {
      background: rgba(249, 115, 22, 0.06);
      border-color: rgba(249, 115, 22, 0.2);
      i { color: $gt-cta; } strong { color: darken($gt-cta, 8%); }
    }
    &--secondary {
      background: rgba(139, 92, 246, 0.06);
      border-color: rgba(139, 92, 246, 0.2);
      i { color: $gt-violet; } strong { color: darken($gt-violet, 8%); }
    }
    &--success {
      background: rgba(16, 185, 129, 0.06);
      border-color: rgba(16, 185, 129, 0.2);
      i { color: $gt-emerald; } strong { color: darken($gt-emerald, 8%); }
    }
  }

  // ──────────── APP-COLLAPSE OVERRIDES ────────────
  .area-card {
    background: $gt-surface !important;
    border: 1px solid $gt-border !important;
    border-radius: 14px !important;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
    overflow: hidden;
    margin-bottom: 14px !important;

    // Kill the default border-left accent (we use chevron in the header instead)
    &.border-left-primary,
    &.border-left-info,
    &.border-left-danger,
    &.border-left-warning,
    &.border-left-secondary,
    &.border-left-success {
      border-left: 1px solid $gt-border !important;
    }

    .card-header {
      background: $gt-surface !important;
      border-bottom: 1px solid $gt-divider !important;
      padding: 14px 20px !important;
      cursor: pointer;
      transition: background 150ms ease;

      &:hover { background: $gt-surface-2 !important; }
    }

    .card-body {
      padding: 18px 20px !important;
      background: $gt-surface !important;
    }
  }

  // section-header (inside collapse header)
  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 12px;

    h4 {
      font-family: 'Plus Jakarta Sans', sans-serif !important;
      font-size: 15px !important;
      font-weight: 700 !important;
      color: $gt-ink !important;
      margin: 0 !important;
      letter-spacing: -0.01em;
    }
  }

  // b-avatar inside section header → restyled
  .b-avatar {
    width: 32px !important;
    height: 32px !important;
    border-radius: 8px !important;

    &.badge-light-primary    { background: rgba(59, 130, 246, 0.12) !important; color: $gt-primary !important; }
    &.badge-light-info       { background: rgba(6, 182, 212, 0.12) !important;  color: $gt-cyan !important; }
    &.badge-light-danger     { background: rgba(239, 68, 68, 0.12) !important;  color: $gt-coral !important; }
    &.badge-light-warning    { background: rgba(249, 115, 22, 0.12) !important; color: $gt-cta !important; }
    &.badge-light-secondary  { background: rgba(139, 92, 246, 0.12) !important; color: $gt-violet !important; }
    &.badge-light-success    { background: rgba(16, 185, 129, 0.12) !important; color: $gt-emerald !important; }

    .b-avatar-custom i { font-size: 13px; }
  }

  // Section count badge (in collapse header)
  .section-header > .badge {
    font-family: 'JetBrains Mono', monospace !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    border-radius: 999px !important;
    padding: 4px 10px !important;
    letter-spacing: 0.04em;
  }
  .section-header .badge-light-primary   { background: rgba(59, 130, 246, 0.12) !important; color: $gt-primary !important; }
  .section-header .badge-light-info      { background: rgba(6, 182, 212, 0.12) !important;  color: $gt-cyan !important; }
  .section-header .badge-light-danger    { background: rgba(239, 68, 68, 0.12) !important;  color: $gt-coral !important; }
  .section-header .badge-light-warning   { background: rgba(249, 115, 22, 0.12) !important; color: $gt-cta !important; }
  .section-header .badge-light-secondary { background: rgba(139, 92, 246, 0.12) !important; color: $gt-violet !important; }
  .section-header .badge-light-success   { background: rgba(16, 185, 129, 0.12) !important; color: $gt-emerald !important; }

  // ──────────── B-CARD generic ────────────
  .card,
  .b-card-code {
    background: $gt-surface !important;
    border: 1px solid $gt-border !important;
    border-radius: 14px !important;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
  }

  // ──────────── FORM CONTROLS ────────────
  .form-group label {
    font-family: 'JetBrains Mono', monospace !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    color: $gt-soft !important;
    letter-spacing: 0.1em !important;
    text-transform: uppercase !important;
    margin-bottom: 6px !important;
  }

  .form-control {
    background: $gt-surface !important;
    border: 1px solid $gt-border !important;
    border-radius: 8px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 13px !important;
    height: 38px !important;
    color: $gt-ink !important;
    box-shadow: none !important;
    transition: all 150ms ease !important;

    &::placeholder { color: $gt-soft; }
    &:focus {
      outline: none !important;
      border-color: $gt-primary !important;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12) !important;
    }
  }

  .v-select {
    .vs__dropdown-toggle {
      background: $gt-surface !important;
      border: 1px solid $gt-border !important;
      border-radius: 8px !important;
      min-height: 38px;
      padding: 0 6px;
      box-shadow: none !important;
    }
    &.vs--open .vs__dropdown-toggle,
    .vs__dropdown-toggle:focus-within {
      border-color: $gt-primary !important;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12) !important;
    }
    .vs__selected, .vs__search {
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 13px;
      color: $gt-ink;
      padding: 0 6px;
      line-height: 36px;
    }
    .vs__open-indicator { fill: $gt-soft; transform: scale(0.75); }
    .vs__dropdown-menu {
      background: $gt-surface;
      border: 1px solid $gt-border;
      border-radius: 8px;
      box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
      padding: 4px;
    }
    .vs__dropdown-option {
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 13px;
      color: $gt-text;
      padding: 8px 10px;
      border-radius: 6px;
      &--highlight { background: $gt-surface-2; color: $gt-primary; }
    }
  }

  // ──────────── BUTTONS ────────────
  .btn {
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    padding: 8px 14px !important;
    transition: all 200ms ease !important;
    box-shadow: none !important;
    border-width: 1px !important;
    display: inline-flex;
    align-items: center;
    gap: 6px;

    i { font-size: 11px; }

    &.btn-primary { background: $gt-primary !important; border-color: $gt-primary !important; color: #fff !important; &:hover { background: darken($gt-primary, 6%) !important; border-color: darken($gt-primary, 6%) !important; box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25) !important; } }
    &.btn-success { background: $gt-emerald !important; border-color: $gt-emerald !important; color: #fff !important; &:hover { background: darken($gt-emerald, 6%) !important; border-color: darken($gt-emerald, 6%) !important; } }
    &.btn-danger  { background: $gt-coral !important; border-color: $gt-coral !important; color: #fff !important; &:hover { background: darken($gt-coral, 6%) !important; border-color: darken($gt-coral, 6%) !important; } }
    &.btn-warning { background: $gt-cta !important; border-color: $gt-cta !important; color: #fff !important; &:hover { background: darken($gt-cta, 6%) !important; border-color: darken($gt-cta, 6%) !important; } }

    // Outlines
    &.btn-outline-primary   { background: transparent !important; border-color: $gt-border !important; color: $gt-primary !important; &:hover { background: rgba(59, 130, 246, 0.06) !important; border-color: $gt-primary !important; } }
    &.btn-outline-success   { background: transparent !important; border-color: $gt-border !important; color: $gt-emerald !important; &:hover { background: rgba(16, 185, 129, 0.06) !important; border-color: $gt-emerald !important; } }
    &.btn-outline-danger    { background: transparent !important; border-color: $gt-border !important; color: $gt-coral !important; &:hover { background: rgba(239, 68, 68, 0.06) !important; border-color: $gt-coral !important; } }
    &.btn-outline-warning   { background: transparent !important; border-color: $gt-border !important; color: $gt-cta !important; &:hover { background: rgba(249, 115, 22, 0.06) !important; border-color: $gt-cta !important; } }
    &.btn-outline-info      { background: transparent !important; border-color: $gt-border !important; color: $gt-cyan !important; &:hover { background: rgba(6, 182, 212, 0.06) !important; border-color: $gt-cyan !important; } }
    &.btn-outline-secondary { background: transparent !important; border-color: $gt-border !important; color: $gt-mute !important; &:hover { background: $gt-surface-2 !important; border-color: $gt-soft !important; color: $gt-ink !important; } }
    &.btn-outline-dark      { background: transparent !important; border-color: $gt-border !important; color: $gt-ink !important; &:hover { background: $gt-ink !important; color: #fff !important; border-color: $gt-ink !important; } }

    // Flats
    &.btn-flat-warning   { background: rgba(249, 115, 22, 0.08) !important; border-color: transparent !important; color: $gt-cta !important; &:hover { background: rgba(249, 115, 22, 0.16) !important; } }
    &.btn-flat-secondary { background: rgba(139, 92, 246, 0.08) !important; border-color: transparent !important; color: $gt-violet !important; &:hover { background: rgba(139, 92, 246, 0.16) !important; } }
    &.btn-flat-success   { background: rgba(16, 185, 129, 0.08) !important; border-color: transparent !important; color: $gt-emerald !important; &:hover { background: rgba(16, 185, 129, 0.16) !important; } }
  }

  .btn-circle {
    width: 32px !important;
    height: 32px !important;
    padding: 0 !important;
    border-radius: 50% !important;
    font-size: 11px !important;
    justify-content: center;
  }

  .finish-button {
    background: $gt-emerald !important;
    border-color: $gt-emerald !important;
    color: #fff !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    padding: 10px 24px !important;
    border-radius: 10px !important;
    font-weight: 600;

    &:hover { background: darken($gt-emerald, 6%) !important; }
  }

  // ──────────── B-TABLE ────────────
  .table {
    background: $gt-surface !important;
    margin-bottom: 0 !important;
    font-family: 'Plus Jakarta Sans', sans-serif;

    thead th {
      font-family: 'JetBrains Mono', monospace !important;
      font-size: 10px !important;
      font-weight: 600 !important;
      color: $gt-soft !important;
      letter-spacing: 0.08em !important;
      text-transform: uppercase;
      background: $gt-surface !important;
      border-bottom: 1px solid $gt-border !important;
      border-top: 0 !important;
      padding: 12px 14px !important;
    }
    tbody tr {
      transition: background 150ms ease;
      background: $gt-surface !important;

      td {
        border-top: 1px solid $gt-divider !important;
        font-size: 12.5px;
        color: $gt-text !important;
        padding: 10px 14px !important;
        vertical-align: middle;
        background: transparent !important;
      }
      &:hover { background: rgba(59, 130, 246, 0.04) !important; }
    }
  }

  // Empty states inside collapse
  .empty-state {
    padding: 28px 16px !important;
    text-align: center;
    color: $gt-soft;

    i { font-size: 28px !important; color: $gt-soft; }
    p {
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 13px;
      color: $gt-mute;
      margin: 8px 0 0;
      font-weight: 500;
    }
  }

  // h3, h5 in modals/inline
  h3 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: $gt-ink;
    letter-spacing: -0.01em;
  }
  h5 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px;
    font-weight: 700;
    color: $gt-ink;
    letter-spacing: -0.005em;
  }
  hr {
    border-top: 1px solid $gt-divider;
  }

  // Badges
  .badge {
    font-family: 'JetBrains Mono', monospace;
    font-weight: 700;
    border-radius: 6px;
    letter-spacing: 0.02em;

    &.badge-light-primary   { background: rgba(59, 130, 246, 0.12) !important; color: $gt-primary !important; }
    &.badge-light-info      { background: rgba(6, 182, 212, 0.12) !important;  color: $gt-cyan !important; }
    &.badge-light-success   { background: rgba(16, 185, 129, 0.12) !important; color: $gt-emerald !important; }
    &.badge-light-warning   { background: rgba(249, 115, 22, 0.12) !important; color: $gt-cta !important; }
    &.badge-light-danger    { background: rgba(239, 68, 68, 0.12) !important;  color: $gt-coral !important; }
    &.badge-light-secondary { background: rgba(148, 163, 184, 0.16) !important; color: $gt-mute !important; }
  }

  @keyframes gt-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.55; transform: scale(0.85); }
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      transition-duration: 0.01ms !important;
    }
  }
}

// ══════════ DARK MODE ══════════
.dark-layout .gt {
  background: #161616;
  color: #d0d2d6;

  .gt-dash-header,
  .area-card,
  .card { background: #1f1f1f !important; border-color: #2c2c2c !important; box-shadow: none !important; }
  .gt-title { color: #e4e6eb; }

  .gt-stat-pill { background: #161616; border-color: #2c2c2c; color: #8e9099; }
  .gt-stat-pill strong { color: #e4e6eb; }

  .area-card .card-header { background: #1f1f1f !important; border-bottom-color: #2c2c2c !important; &:hover { background: #242424 !important; } }
  .area-card .card-body { background: #1f1f1f !important; }
  .section-header h4 { color: #e4e6eb !important; }

  .form-control { background: #1f1f1f !important; border-color: #2c2c2c !important; color: #d0d2d6 !important; &:focus { background: #242424 !important; } }

  .v-select .vs__dropdown-toggle { background: #1f1f1f !important; border-color: #2c2c2c !important; }
  .v-select .vs__selected, .v-select .vs__search { color: #d0d2d6; }
  .v-select .vs__dropdown-menu { background: #242424; border-color: #3a3a3a; }
  .v-select .vs__dropdown-option { color: #d0d2d6; }
  .v-select .vs__dropdown-option--highlight { background: #2c2c2c; color: #fff; }

  .table thead th { background: #1f1f1f !important; color: #6e7079 !important; border-bottom-color: #2c2c2c !important; }
  .table tbody tr td { border-top-color: #2c2c2c !important; color: #d0d2d6 !important; }
  .table tbody tr:hover { background: rgba(59, 130, 246, 0.08) !important; }

  hr { border-top-color: #2c2c2c; }
  h3, h5 { color: #e4e6eb; }
}

// ══════════════════════════════════════════════════════════════
// MODAL — REPORTE DE PRODUCCIÓN (.gt-modal)
// Bootstrap-vue renders modals to body, so this is global
// ══════════════════════════════════════════════════════════════

.gt-modal {

  // Tokens (re-declared since we're outside .gt scope)
  $m-bg:        #F8FAFC;
  $m-surface:   #FFFFFF;
  $m-surface-2: #F1F5F9;
  $m-border:    #E2E8F0;
  $m-divider:   #EEF2F7;
  $m-ink:       #1E293B;
  $m-mute:      #64748B;
  $m-soft:      #94A3B8;
  $m-primary:   #3B82F6;
  $m-cta:       #F97316;
  $m-emerald:   #10B981;
  $m-coral:     #EF4444;

  // Modal shell — force much wider than default xl
  &.modal .modal-dialog,
  .modal-dialog,
  &.modal-xl .modal-dialog {
    max-width: 98vw !important;
    width: 98vw !important;
    margin: 1rem auto !important;
  }
  .modal-content { width: 100% !important; }

  .modal-content {
    background: $m-surface !important;
    border: 1px solid $m-border !important;
    border-radius: 16px !important;
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.2) !important;
    overflow: hidden;
    font-family: 'Plus Jakarta Sans', -apple-system, sans-serif;
    color: $m-ink;
  }

  // Header
  .modal-header {
    background: $m-surface !important;
    border-bottom: 1px solid $m-divider !important;
    padding: 16px 22px !important;
    align-items: center;

    .modal-title {
      font-family: 'Plus Jakarta Sans', sans-serif !important;
      font-size: 17px !important;
      font-weight: 700 !important;
      color: $m-ink !important;
      letter-spacing: -0.015em !important;
      text-transform: none !important;
      display: inline-flex !important;
      align-items: center;
      gap: 10px;

      &::before {
        content: '›';
        font-family: 'JetBrains Mono', monospace;
        font-size: 20px;
        font-weight: 800;
        color: $m-primary;
        line-height: 1;
      }
    }

    .close {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      background: $m-surface-2;
      color: $m-mute;
      opacity: 1;
      font-size: 18px;
      transition: all 150ms ease;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      margin: 0;
      text-shadow: none;

      &:hover { background: $m-coral; color: #fff; }
    }
  }

  // Body
  .modal-body {
    padding: 18px 22px;
    background: $m-surface;
    max-height: calc(100vh - 140px);
    overflow-y: auto;

    &::-webkit-scrollbar { width: 8px; }
    &::-webkit-scrollbar-track { background: transparent; }
    &::-webkit-scrollbar-thumb { background: $m-border; border-radius: 8px; }
    &::-webkit-scrollbar-thumb:hover { background: $m-soft; }

    // Squash bootstrap col mb-2 default spacing inside the modal
    .col-12.mb-2 {
      margin-bottom: 4px !important;
      padding-top: 0;
      padding-bottom: 0;
    }
    .row { margin-bottom: 0; }
  }

  // Section H3 — Pedido, Inicio y Fin, Correcciones
  h3 {
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 15px !important;
    font-weight: 700 !important;
    color: $m-ink !important;
    margin: 0 !important;
    padding: 0;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    letter-spacing: -0.01em;
    text-transform: none;
    line-height: 1.2;

    &::before {
      content: '›';
      font-family: 'JetBrains Mono', monospace;
      font-size: 17px;
      font-weight: 800;
      color: $m-primary;
      line-height: 1;
    }
  }

  // Section H5 — Corte, Mano, Aparado (only inside modal body, not the modal title)
  .modal-body h5 {
    font-family: 'JetBrains Mono', monospace !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    color: $m-mute !important;
    letter-spacing: 0.14em !important;
    text-transform: uppercase !important;
    margin: 0 !important;
    padding: 2px 0;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    line-height: 1.1;

    &::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: $m-cta;
    }
  }

  // HR dividers
  hr {
    border: 0;
    border-top: 1px solid $m-divider;
    margin: 8px 0 4px;
  }

  // Form groups
  .form-group {
    margin-bottom: 8px;

    label {
      font-family: 'JetBrains Mono', monospace;
      font-size: 9.5px;
      font-weight: 600;
      color: $m-soft;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      margin-bottom: 3px;
      display: block;
    }
  }

  // Form controls
  .form-control {
    background: $m-surface;
    border: 1px solid $m-border;
    border-radius: 8px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12.5px;
    height: 36px;
    padding: 0 11px;
    color: $m-ink;
    box-shadow: none;
    transition: all 150ms ease;

    &::placeholder { color: $m-soft; opacity: 0.7; }

    &:focus {
      outline: none;
      border-color: $m-primary;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
    }

    &[type="date"], &[type="time"], &[type="number"] {
      font-family: 'JetBrains Mono', monospace;
      font-feature-settings: "tnum";
    }
  }

  // Textareas — force taller, ignore the 36px height
  textarea.form-control,
  .form-control[rows],
  .form-control--textarea {
    height: auto !important;
    min-height: 110px !important;
    padding: 10px 12px !important;
    line-height: 1.5;
    resize: vertical;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
  }

  // v-select
  .v-select {
    .vs__dropdown-toggle {
      background: $m-surface !important;
      border: 1px solid $m-border !important;
      border-radius: 8px !important;
      min-height: 36px;
      padding: 0 6px;
      box-shadow: none !important;
    }
    &.vs--open .vs__dropdown-toggle,
    .vs__dropdown-toggle:focus-within {
      border-color: $m-primary !important;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12) !important;
    }
    .vs__selected, .vs__search {
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 12.5px;
      color: $m-ink;
      padding: 0 6px;
      line-height: 34px;
    }
    .vs__open-indicator { fill: $m-soft; transform: scale(0.75); }
    .vs__dropdown-menu {
      background: $m-surface;
      border: 1px solid $m-border;
      border-radius: 8px;
      box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
      padding: 4px;
    }
    .vs__dropdown-option {
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 12.5px;
      color: $m-ink;
      padding: 7px 10px;
      border-radius: 6px;
      &--highlight { background: $m-surface-2; color: $m-primary; }
    }
  }

  // Add (+) and delete (trash) buttons → bigger soft squircles
  .btn.btn-circle {
    width: 36px !important;
    height: 36px !important;
    padding: 0 !important;
    border-radius: 10px !important;
    font-size: 12px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    transition: all 200ms ease !important;
    border-width: 1px !important;

    // Style override: + button (success)
    &.btn-outline-success {
      background: rgba(16, 185, 129, 0.08) !important;
      color: $m-emerald !important;
      border-color: rgba(16, 185, 129, 0.3) !important;

      &:hover {
        background: $m-emerald !important;
        color: #fff !important;
        border-color: $m-emerald !important;
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25) !important;
      }
    }

    // Style override: trash button (danger)
    &.btn-outline-danger {
      background: rgba(239, 68, 68, 0.08) !important;
      color: $m-coral !important;
      border-color: rgba(239, 68, 68, 0.3) !important;

      &:hover {
        background: $m-coral !important;
        color: #fff !important;
        border-color: $m-coral !important;
        box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25) !important;
      }
    }

    // Reset margin-top hack from inline style
    &[style*="margin-top"] {
      margin-top: 22px !important;
    }
  }

  // The + buttons floating outside columns
  > .btn.btn-circle, .modal-body > .btn.btn-circle, .row > .btn.btn-circle {
    margin-left: 16px !important;
    margin-bottom: 6px !important;
    margin-top: 4px !important;
  }

  // Crear reporte button (special)
  .finish-button {
    background: $m-emerald !important;
    border-color: $m-emerald !important;
    color: #fff !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    padding: 10px 28px !important;
    border-radius: 10px !important;
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25) !important;
    transition: all 200ms ease;

    &:hover {
      background: darken($m-emerald, 6%) !important;
      border-color: darken($m-emerald, 6%) !important;
      box-shadow: 0 6px 18px rgba(16, 185, 129, 0.32) !important;
    }
  }

  // Generic .btn
  .btn:not(.btn-circle):not(.finish-button) {
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    padding: 8px 16px !important;
    transition: all 200ms ease !important;
    box-shadow: none !important;

    &.btn-primary {
      background: $m-primary !important;
      border-color: $m-primary !important;
      color: #fff !important;
      &:hover { background: darken($m-primary, 6%) !important; border-color: darken($m-primary, 6%) !important; }
    }
  }

  // Tooltip icon next to "Correcciones" title
  .b-tooltip, [data-toggle="tooltip"] {
    color: $m-mute !important;
  }

  // Spacing reset for inline styles forcing padding-left/right
  .row[style*="padding-left: 20px"] {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 4px !important;
    background: $m-bg;
    border: 1px solid $m-divider;
    border-radius: 10px;
    padding: 8px 12px !important;
    width: 100% !important;

    .form-group { margin-bottom: 0 !important; }
  }

  // Dark mode
  .dark-layout & {
    .modal-content { background: #1f1f1f; border-color: #2c2c2c; color: #d0d2d6; }
    .modal-header { background: #1f1f1f; border-bottom-color: #2c2c2c; }
    .modal-title { color: #e4e6eb; }
    .modal-header .close { background: #161616; color: #8e9099; }
    .modal-body { background: #1f1f1f; }
    h3 { color: #e4e6eb; }
    h5 { color: #8e9099; }
    hr { border-top-color: #2c2c2c; }
    .form-control { background: #161616; border-color: #2c2c2c; color: #d0d2d6; &:focus { background: #242424; } }
    .v-select .vs__dropdown-toggle { background: #161616 !important; border-color: #2c2c2c !important; }
    .v-select .vs__selected, .v-select .vs__search { color: #d0d2d6; }
    .row[style*="padding-left: 20px"] { background: #161616 !important; border-color: #2c2c2c; }
  }
}
</style>